import type { MessageKey } from './en.ts';

/** Norsk bokmål. Must cover every key in en (enforced by the type). */
export const nbNO: Record<MessageKey, string> = {
  'app.name': 'Autho',
  'app.loading': 'Laster…',
  'app.error.generic': 'Noe gikk galt.',
  'app.error.tooSoon':
    'Det ble nettopp sendt en innloggingslenke til den adressen. Vent litt før du ber om en ny — og se i e-posten din, den første virker fortsatt.',
  'app.error.notConfigured':
    'Denne kopien av Autho ble startet uten innloggingstjenesten. Ingen kan logge inn før det er rettet; det er ikke noe du har gjort.',
  'app.error.offline':
    'Du ser ut til å være frakoblet. Det er ingenting galt med Autho — det virker igjen når tilkoblingen gjør det.',
  'app.error.unreachable':
    'Autho-serveren svarer ikke. Dette er ikke tilkoblingen din: serveren er nede, starter på nytt, eller er ikke startet.',
  'app.error.expired': 'Økten din er ikke gyldig lenger. Logger deg ut så du kan logge inn igjen.',
  'app.error.refused': 'Du har ikke tilgang til det.',
  'app.error.server': 'Autho-serveren fikk en feil. Den er logget.',
  'app.error.upstream':
    'Autho fikk ikke kontakt med Brønnøysund. Det er registeret som er utilgjengelig, ikke tilkoblingen din.',
  'app.error.providerNotEnabled':
    'Autho har ikke fullført oppsettet mot denne leverandøren ennå, så det finnes ikke noe å lese. Det er vårt å rette, ikke ditt — ingenting er lest og ingenting er brukt.',
  'app.error.reconnect':
    'Leverandøren lar ikke Autho lese dette med de tillatelsene denne kontoen har gitt. Koble til kontoen på nytt og ta med det som mangler.',
  'app.error.providerTooFast':
    'Leverandøren ber Autho om å roe ned. Ingenting ble lest og ingenting brukt — prøv igjen om noen minutter.',
  'app.error.providerUnavailable':
    'Leverandøren svarte ikke. Ingenting er lest og ingenting er brukt; prøv igjen om litt.',
  'app.error.wrongProfile':
    'Dette hører til en annen type profil enn den du har åpen, personlig eller et selskaps. Bytt profil og prøv igjen der.',
  'app.error.wall':
    'Autho stoppet denne forespørselen fordi den gikk inn i en annen profil. Ingenting ble lest, og det er logget.',
  'app.error.unmarked':
    'Denne adressen er ennå ikke merket med hvilken type profil den hører til, så Autho svarer ikke på den. Feilen er logget.',
  'app.error.wrongWords':
    'Noen av disse tilgangene hører til den andre typen profil. Gi dem fra den profilen i stedet.',

  'auth.signIn.title': 'Logg inn i Autho',
  'auth.signIn.google': 'Fortsett med Google',
  'auth.signIn.microsoft': 'Fortsett med Microsoft',
  'auth.signIn.provider.denied':
    'Innloggingen med {provider} ble avbrutt, så du er ikke logget inn. Prøv igjen, eller bruk e-post.',
  'auth.signIn.provider.failed':
    'Innloggingen med {provider} ble ikke fullført. Prøv igjen, eller bruk e-post.',
  'auth.signIn.provider.unknown': 'innloggingstjenesten din',
  'auth.signIn.provider.google': 'Google',
  'auth.signIn.provider.azure': 'Microsoft',
  'eid.vipps': 'Vipps',
  'eid.bankid': 'BankID',
  'eid.signIn': 'Fortsett med {provider}',
  'eid.signIn.test': 'Vipps og BankID er i testmiljøene sine her: bare testbrukere kan logge inn.',
  'eid.return.working': 'Fullfører innloggingen med {provider}…',
  'eid.return.back': 'Tilbake til innlogging',
  'eid.return.settings': 'Tilbake til Innstillinger',
  'eid.linked': '{provider} er lagt til. Du kan logge inn med det fra nå av.',
  'eid.refused.noFlow':
    'Denne innloggingen ble ikke startet her, eller den tok for lang tid. Start på nytt.',
  'eid.refused.cancelled': 'Innloggingen ble avbrutt.',
  'eid.refused.noSignUp':
    'Ingen registrering ventet i denne nettleseren, eller den tok mer enn 30 minutter. Registrer deg med BankID på nytt, og åpne lenken i samme nettleser.',
  'eid.refused.emailUnverified':
    'E-postadressen din er ikke bekreftet ennå. Åpne lenken i e-posten vi sendte deg.',
  'eid.signUp.title': 'Fullfør registreringen',
  'eid.signUp.verified': '{provider} bekreftet at du er {name}.',
  'eid.signUp.explain':
    'Oppgi e-postadressen du vil logge inn med. Vi sender en lenke til den: åpne den i denne nettleseren innen 30 minutter, så legges {provider} til den nye kontoen din.',
  'eid.signUp.email': 'E-postadresse',
  'eid.signUp.submit': 'Send lenken',
  'eid.signUp.finishing': 'Legger BankID til kontoen din…',
  'eid.signUp.done': 'BankID er lagt til kontoen din. Du kan logge inn med den fra nå av.',
  'eid.signUp.close': 'Lukk',
  'eid.refused.incomplete':
    'Tilbyderen oppga ikke fullt ut hvem du er: navn og fødselsnummer trengs.',
  'eid.refused.number': 'Fødselsnummeret tilbyderen oppga kunne ikke bekreftes.',
  'eid.refused.heldByAnother': 'Denne eID-en er allerede lagt til en annen konto.',
  'eid.refused.hasAnother': 'Du har allerede en annen eID av denne typen. Fjern den først.',
  'eid.refused.notOffered': 'Innlogging på denne måten tilbys ikke her.',
  'eid.refused.other': 'Innloggingen kunne ikke fullføres. Ingenting er endret.',
  'shared.title': 'Delt med selskaper',
  'shared.explain':
    'La din egen Autho Assistant og agentene du har koblet til i et selskap lese noen av dine personlige kilder der, direkte. Aldri innholdet i en melding, ingenting lagres i selskapet, og hver lesing står i din revisjonslogg. Inntil 90 dager, og du kan trekke det tilbake når som helst.',
  'shared.none': 'Du deler ingenting med noe selskap.',
  'shared.companyLeft': 'Et selskap du ikke lenger er med i',
  'shared.purpose': 'Formål: {purpose}',
  'shared.until': 'til {at}',
  'shared.ended': 'avsluttet {at}',
  'shared.expiredAt': 'utløpt {at}',
  'shared.revoke': 'Trekk tilbake',
  'shared.state.live': 'Delt',
  'shared.state.expired': 'Utløpt',
  'shared.state.revoked': 'Trukket tilbake',
  'shared.state.replaced': 'Erstattet av en nyere tilgang',
  'shared.state.membershipEnded': 'Avsluttet: du er ikke lenger medlem',
  'shared.word.mail': 'e-posthoder',
  'shared.word.calendar': 'kalenderhendelser',
  'shared.word.drive': 'filnavn',
  'shared.noCompany': 'Du er ikke med i noe selskap å dele med.',
  'shared.noAccount': 'Koble til en konto i Personlig først.',
  'shared.form.company': 'Selskap',
  'shared.form.chooseCompany': 'Velg et selskap',
  'shared.form.accounts': 'Kontoer',
  'shared.form.words': 'Hva den kan lese',
  'shared.form.noBodies':
    'Emner, avsendere og datoer, hendelser og filnavn. Aldri hva en melding sier.',
  'shared.form.purpose': 'Formål (lagres med tilgangen og hvert svar)',
  'shared.form.days': 'Dager (høyst {max})',
  'shared.form.share': 'Del',
  'eid.settings.title': 'Logg inn med eID',
  'eid.settings.explain':
    'Legg til Vipps eller BankID som en måte å logge inn på. Autho beholder navnet og fødselsdatoen tilbyderen bekreftet, aldri fødselsnummeret ditt.',
  'eid.settings.none': 'Ingen eID lagt til.',
  'eid.settings.born': 'født {date}',
  'eid.settings.verified': 'bekreftet {at}',
  'eid.settings.add': 'Legg til {provider}',
  'eid.settings.remove': 'Fjern {provider}',
  'eid.settings.off': 'Innlogging med eID er ikke slått på her.',
  'auth.signIn.email.label': 'E-post',
  'auth.signIn.email.submit': 'Send meg en innloggingslenke',
  'auth.signIn.email.sent': 'Sjekk {email} for en innloggingslenke.',
  'auth.signIn.providerUnavailable': 'Innlogging med {provider} er ikke satt opp i dette miljøet.',
  'auth.signOut': 'Logg ut',

  'profile.signedInAs': 'Logget inn som {email}',
  'profile.signedInWithoutEmail': 'Logget inn uten e-postadresse',
  'profile.emailVerified': 'e-post bekreftet',
  'profile.emailNotVerified': 'e-post ikke bekreftet',
  'profile.missing':
    'Autho fant ingen profil for deg — ikke engang din egen, som enhver innlogging har. Det er en feil i Autho, ikke noe du har gjort.',
  'profile.switch': 'Bytt profil',
  'profile.kind.me': 'Din egen profil',
  'profile.kind.orgNumbered': 'Organisasjon · {orgnr}',

  'tenant.orgnr.title': 'Organisasjonsnummer',
  'tenant.orgnr.explain':
    'Hvilket av denne organisasjonens selskaper er organisasjonen selv? Du angir det én gang, og det kan ikke endres her etterpå.',
  'tenant.orgnr.choose': 'Velg selskapet',
  'tenant.orgnr.set': 'Dette er organisasjonen',
  'tenant.orgnr.is': 'Denne organisasjonen har organisasjonsnummer {orgnr}.',
  'settings.profiles': 'Profiler',
  'settings.profiles.switch': 'Du bytter mellom profilene dine øverst på hver side.',
  'tenant.add': 'Legg til et selskap',
  'tenant.add.orgnr': 'Organisasjonsnummer',
  'tenant.add.admin': 'Du blir administrator.',
  'tenant.add.submit': 'Legg til selskapet',
  'tenant.add.error.invalid_orgnr':
    'Det er ikke et gyldig norsk organisasjonsnummer. Sjekk de ni sifrene og prøv igjen.',
  'tenant.add.error.email_unverified':
    'Bare en person med bekreftet e-post kan legge til et selskap, og e-posten din er ikke bekreftet ennå. Ingenting ble lagt til.',
  'tenant.add.error.email_check_unavailable':
    'Autho fikk ikke sjekket om e-posten din er bekreftet, så ingenting ble lagt til. Prøv igjen om litt.',
  'tenant.add.error.org_exists': 'Du har allerede en profil for dette selskapet.',
  'tenant.add.error.orgnr_not_found':
    '{orgnr} er ikke registrert i Enhetsregisteret. Sjekk nummeret og prøv igjen.',
  'tenant.add.error.company_dissolved':
    'Enhetsregisteret oppgir {orgnr} som slettet, så det kan ikke legges til.',
  'tenant.add.error.provider_unavailable':
    'Brønnøysund svarte ikke, så selskapet kunne ikke slås opp. Ingenting ble lagt til; prøv igjen om litt.',
  'tenant.kind.me': 'Personlig',
  'tenant.kind.org': 'Organisasjon',

  'nav.structure': 'Struktur',
  'nav.chat': 'Chat',
  'chat.title': 'Chat',
  'chat.description':
    'Spør om det denne profilen inneholder. Autho Assistant leser bare det tilgangen tillater, og hvert tall den oppgir sjekkes mot det den leste.',
  'chat.new': 'Ny tråd',
  'chat.threads': 'Trådene dine',
  'chat.none': 'Ingen tråder ennå. Start en med Ny tråd.',
  'chat.untitled': 'Tråd fra {at}',
  'chat.spend.saved': 'Hurtigbufring hos leverandøren sparte {saved}.',
  'chat.spend':
    '{calls, plural, =0 {Ingenting brukt i denne tråden ennå.} one {Denne tråden har kostet {amount}, over # modellkall.} other {Denne tråden har kostet {amount}, over # modellkall.}}',
  'chat.delete': 'Slett tråden',
  'chat.deleteConfirm': 'Slette denne tråden og alt i den nå? Det kan ikke angres.',
  'chat.kept':
    'Bare du ser trådene dine, her og ingen andre steder. Spørsmål og svar beholdes i 90 dager og slettes deretter.',
  'chat.thread.empty': 'Ingenting er spurt i denne tråden ennå.',
  'chat.question': 'Spørsmålet ditt',
  'chat.ask': 'Spør',
  'chat.how':
    'Autho Assistant svarer som sin egen agent, med tilgangen den har under Agenter. Det den leste vises mens den svarer og føres i revisjonsloggen; det verktøyene svarte, lagres aldri.',
  'chat.answering': 'Svarer…',
  'chat.step.read': 'Leste {tool}',
  'chat.step.refused': '{tool} ble avvist',
  'chat.sources': 'Bygger på:',
  'chat.kind.company': 'Selskap',
  'chat.kind.counterparty': 'Kunde eller leverandør',
  'chat.kind.document': 'Dokument',
  'chat.kind.belief': 'Oppfatning',
  'chat.kind.person': 'Person',
  'chat.kind.mail': 'E-post',
  'chat.kind.item': 'Element',
  'chat.federated.unkept':
    'Hentet fra dine personlige kilder, under tilgangen du delte med dette selskapet. Lagres ikke: det er ikke her når du kommer tilbake.',
  'chat.federated.stub': 'Besvart fra en tilgang; ikke lagret.',
  'chat.federated.reask': 'Spør igjen',
  'chat.kind.personal': 'Dine personlige kilder',
  'chat.kind.ledger': 'Hovedbokslinje',
  'chat.kind.record': 'Opplysning',
  'chat.producedBy': '{model} · {region} · {at}',
  'chat.scope.label': 'Selskaper',
  'chat.scope.summaryAll': 'Svarer ut fra alle selskapene Autho Assistant dekker.',
  'chat.scope.summaryOnly': 'Svarer bare ut fra {names}.',
  'chat.scope.summaryLeaving':
    'Svarer ut fra alle selskapene Autho Assistant dekker, unntatt {names}.',
  'chat.scope.gone': 'et selskap tilgangen ikke lenger dekker',
  'chat.scope.change': 'Endre',
  'chat.scope.all': 'Alle selskapene Autho Assistant dekker',
  'chat.scope.leaveOut': 'Utelat:',
  'chat.scope.only': 'Bare disse:',
  'chat.scope.save': 'Lagre',
  'chat.scope.cancel': 'Avbryt',
  'chat.scope.none': 'Behold minst ett selskap.',
  'chat.scope.how':
    'Senere svar i denne tråden leser bare disse selskapene. Hvilke selskaper Autho Assistant dekker, bestemmes av tilgangen den har under Agenter.',
  'chat.switched': 'Byttet til {model}',
  'chat.switched.asked': 'byttet fra {from} fordi du ba om det',
  'chat.switched.numberCheck': 'byttet fra {from}: svaret hadde et tall ingen kilde støttet',
  'chat.askStronger': 'Spør en sterkere modell ({model})',
  'chat.reason.noStronger':
    'Ikke besvart: det finnes ingen sterkere modell denne profilen kan bruke, så tråden beholder den den har.',
  'chat.unchecked':
    'Ikke funnet i det Autho Assistant leste: ikke ta det som et tall fra dine opplysninger.',
  'chat.uncheckedNote':
    '{count, plural, one {# tall i dette svaret ble ikke funnet i det Autho Assistant leste, og er merket.} other {# tall i dette svaret ble ikke funnet i det Autho Assistant leste, og er merket.}}',
  'chat.reason.region':
    'Ikke besvart: denne profilen holder KI-behandling i EØS, og Chats modell tilbys ikke der.',
  'chat.reason.modelChanged':
    'Ikke besvart: denne tråden beholder modellen som svarte først. Start en ny tråd.',
  'chat.reason.unavailable': 'Ikke besvart: Chat er ikke slått på i denne installasjonen.',
  'chat.reason.modelFailed':
    'Ikke besvart: modellen svarte ikke, eller dagens budsjett er brukt opp. Ingenting ble gitt videre til en annen modell.',
  'chat.reason.interrupted': 'Ikke besvart: svaret ble avbrutt. Spør igjen.',
  'chat.reason.other': 'Ikke besvart. Spør igjen.',
  'nav.beliefs': 'Oppfatninger',
  'nav.mind': 'Sinn',
  'nav.assistant': 'Assistent',
  'nav.configure': 'Oppsett',
  'nav.access': 'Tilgang',
  'nav.engine': 'Motor',
  'nav.agents': 'Agenter',
  'nav.approvals': 'Godkjenninger',
  'nav.clarify': 'Avklar',
  'nav.audit': 'Revisjonslogg',
  'nav.settings': 'Innstillinger',
  'notFound.title': 'Ingenting her',
  'notFound.body': 'Det finnes ingen side på denne adressen.',
  'notFound.home': 'Gå til {screen}',

  'switcher.selectedCount': '{count, plural, one {# enhet} other {# enheter}}',
  'scope.inView.one': 'Viser {name} · {orgnr}.',
  'scope.inView.several': 'Viser {count, plural, one {# selskap} other {# selskaper}}.',
  'scope.inView.another': 'Åpne et annet selskap fra Struktur.',
  'scope.inView.whole': 'Vis hele profilen.',

  'entity.state.managed': 'Forvaltet',
  'entity.state.linked': 'Koblet',
  'entity.state.external': 'Ekstern',
  'entity.state.managed.description': 'Denne organisasjonen kobler til enhetens egne systemer.',
  'entity.state.linked.description':
    'Enheten har sin egen Autho-organisasjon og deler data gjennom en fullmakt.',
  'entity.state.external.description':
    'Et eierskap eller en investering: bare Brønnøysund-data og manuell verdivurdering.',
  'entity.state.linked.unavailable': 'Kobling krever føderasjon, som kommer i en senere milepæl.',
  'entity.status.active': 'Aktiv',
  'entity.status.dissolved': 'Slettet',
  'entity.status.bankrupt': 'Konkurs',
  'entity.flag.under_liquidation': 'Under avvikling',
  'entity.flag.compulsory_dissolution': 'Under tvangsavvikling eller tvangsoppløsning',
  'entity.flag.bankrupt': 'Konkurs registrert',

  'structure.title': 'Struktur',
  'structure.empty': 'Ingen enheter ennå. Legg til en med organisasjonsnummer.',
  'structure.add.title': 'Legg til enhet',
  'structure.add.orgnr': 'Organisasjonsnummer',
  'structure.add.orgnr.invalid': 'Skriv inn et gyldig organisasjonsnummer på 9 siffer.',
  'structure.add.state': 'Tilstand',
  'structure.add.submit': 'Hent fra Brønnøysund',
  'structure.add.notFound': '{orgnr} er ikke registrert i Enhetsregisteret.',
  'structure.add.duplicate': '{orgnr} finnes allerede i denne organisasjonen.',
  'structure.column.name': 'Navn',
  'structure.column.orgnr': 'Org.nr.',
  'structure.column.form': 'Form',
  'structure.column.state': 'Tilstand',
  'structure.column.status': 'Status',
  'structure.column.synced': 'Brønnøysund',
  'structure.changeState': 'Endre tilstand',
  'structure.resync': 'Oppdater fra Brønnøysund',
  'structure.freshness': 'Sjekket {ago}',
  'structure.freshness.never': 'Aldri sjekket',
  'assets.title': 'Eiendeler',
  'assets.intro':
    'Selskaper denne organisasjonen eier. Forvaltet har regnskapet sitt her; Manuell er en eierpost du beskriver selv.',
  'assets.empty':
    'Ingen eiendeler ennå. Merk et selskap over som eiendel, eller legg til et med organisasjonsnummer.',
  'assets.state.managed': 'Forvaltet',
  'assets.state.manual': 'Manuell',
  'assets.state.managed.description':
    'Regnskapet føres i denne organisasjonen, der det allerede er.',
  'assets.state.manual.description': 'Beskrevet for hånd: her føres ikke noe regnskap for det.',
  'assets.column.company': 'Selskap',
  'assets.column.orgnr': 'Org.nr.',
  'assets.column.state': 'Type',
  'assets.column.stake': 'Eierandel',
  'assets.column.notes': 'Notater',
  'assets.add.title': 'Legg til eiendel',
  'assets.add.from': 'Selskap',
  'assets.add.from.new': 'Et nytt selskap, med organisasjonsnummer',
  'assets.add.orgnr': 'Organisasjonsnummer',
  'assets.add.state': 'Type',
  'assets.add.stake': 'Eierandel (% av aksjekapitalen)',
  'assets.add.notes': 'Notater',
  'assets.add.submit': 'Legg til eiendel',
  'assets.edit': 'Endre',
  'assets.edit.save': 'Lagre',
  'assets.edit.cancel': 'Avbryt',
  'assets.edit.title': 'Eierandel og notater for {name}',
  'assets.error.own_company':
    'Denne selskapsprofilen er selve selskapet, så det er ikke en av sine egne eiendeler.',
  'assets.error.asset_exists': 'Det selskapet er allerede en eiendel.',
  'assets.error.linked_later': 'Et koblet selskap kan ikke være en eiendel ennå.',
  'assets.error.stake': 'Skriv eierandelen i prosent, over 0 og høyst 100, med høyst to desimaler.',
  'assets.error.notes_too_long': 'Notatene kan være på høyst 2 000 tegn.',
  'assets.error.stake_required':
    'Oppgi eierandelen: den direkte andelen av aksjekapitalen, i prosent.',
  'assets.error.asset_ended':
    'Den eiendelen er avsluttet og beholdes som historikk; den endres ikke.',
  'assets.error.invalid_date': 'Skriv dagen eiendelen ble avsluttet.',
  'assets.end': 'Avslutt',
  'assets.end.title': 'Avslutt {name}',
  'assets.end.reason': 'Hvordan den ble avsluttet',
  'assets.end.reason.sold': 'Solgt',
  'assets.end.reason.dissolved': 'Oppløst',
  'assets.end.on': 'Dato',
  'assets.end.submit': 'Avslutt eiendel',
  'assets.remove': 'Registrert ved en feil',
  'assets.remove.confirm':
    'Fjerne {name}, registrert ved en feil? Revisjonsloggen beholder en oppføring om at den var her.',
  'assets.remove.submit': 'Fjern',
  'assets.ended.title': 'Avsluttet',
  'assets.ended.row': '{reason} {date}',
  'register.title': 'Eierskap',
  'register.source': 'Skatteetaten, per 31.12.{year}',
  'register.intro':
    'Fra Skatteetatens aksjonærregister: selskapene som eier denne organisasjonens selskaper, og hva de eier. Bare eierskap mellom to selskaper tas vare på. Registeret er per 31. desember, ikke i dag, og erstatter aldri en eierandel du har skrevet inn.',
  'register.none': 'Ikke importert ennå: Skatteetaten publiserer registeret én gang i året.',
  'register.ownedBy': 'Eies av',
  'register.owns': 'Eier',
  'register.nothing': 'Ingenting i registeret.',
  'register.allShares': 'Alle aksjer',
  'register.typed': 'Du skrev {stake}',
  'register.column.company': 'Selskap',
  'register.column.stake': 'Eierandel',
  'register.import': 'Importer aksjonærregisteret',
  'register.import.what':
    'Skatteetaten publiserer hele registeret én gang i året, per 31. desember, som en fil du bestiller fra Skatteetaten. Autho leser den her, i nettleseren din, og sender bare eierskap mellom to selskaper der ett av dem er i denne organisasjonens struktur.',
  'register.import.dropped':
    'Forkastes der filen leses, og sendes aldri: hver rad der eieren er en person; en utenlandsk eier, som ikke har norsk organisasjonsnummer og ikke kan skilles fra en person; og et nummer med feil kontrollsiffer.',
  'register.import.year': 'Registeret per 31. desember',
  'register.import.file': 'Registerfilen (CSV)',
  'register.import.submit': 'Importer',
  'register.import.reading': 'Leser filen…',
  'register.import.done':
    'Importerte {year}: {kept, plural, one {# eierskap} other {# eierskap}} tatt vare på for denne organisasjonen. Forkastet i nettleseren: {person, plural, one {# rad med en person} other {# rader med personer}}, {foreign, plural, one {# utenlandsk eier} other {# utenlandske eiere}}, {invalid, plural, one {# nummer med feil kontrollsiffer} other {# numre med feil kontrollsiffer}}, {malformed, plural, one {# linje som ikke var et eierskap} other {# linjer som ikke var eierskap}} og {other, plural, one {# eierskap mellom andre selskaper} other {# eierskap mellom andre selskaper}}.',
  'register.import.questions':
    '{count, plural, one {# eierandel avviker} other {# eierandeler avviker}} fra det du skrev. Avklar spør om hver.',
  'register.error.not_a_company_row':
    'En rad hadde en eier som ikke var et selskap, så ingenting ble importert. Les filen på nytt her.',
  'register.error.malformed_row':
    'En rad var ikke et eierskap registeret viser, så ingenting ble importert.',
  'register.error.duplicate_row': 'Et eierskap stod to ganger, så ingenting ble importert.',
  'register.error.invalid_year': 'Velg et tidligere år fra 2000.',
  'register.error.too_large': 'For mange rader på én gang, så ingenting ble importert.',
  'clarify.registerStake.question':
    'Du skrev {typed} for {name} ({orgnr}); Skatteetatens register per 31.12.{year} sier {register}. Hva er riktig?',
  'clarify.registerStake.typed': 'Behold {typed}',
  'clarify.registerStake.register': 'Bruk {register}',
  'clarify.asset.suggestion': 'Skatteetaten, per 31.12.{year}: {stake}',
  'clarify.asset.useSuggestion': 'Bruk den',
  'clarify.asset.question':
    'Er {name} ({orgnr}) en av denne organisasjonens eiendeler? Hvis ja, oppgi den direkte andelen av aksjekapitalen.',
  'clarify.asset.yes': 'Ja, en eiendel',
  'clarify.asset.no': 'Nei, ikke en eiendel',

  'entity.section.overview': 'Oversikt',
  'entity.section.roles': 'Roller',
  'entity.section.subUnits': 'Underenheter',
  'entity.section.filedAccounts': 'Innsendte regnskap',
  'entity.field.name': 'Navn',
  'entity.field.form': 'Organisasjonsform',
  'entity.field.nace': 'Næringskode',
  'entity.field.registeredAt': 'Registrert',
  'entity.field.vatRegistered': 'MVA-registrert',
  'entity.field.businessAddress': 'Forretningsadresse',
  'entity.field.postalAddress': 'Postadresse',
  'entity.field.shareCapital': 'Aksjekapital',
  'entity.field.employees': 'Ansatte',
  'entity.roles.empty': 'Brønnøysund oppgir ingen roller.',
  'entity.roles.holder': 'Innehaver',
  'entity.roles.role': 'Rolle',
  'entity.roles.deregistered': 'Fratrådt',
  'entity.subUnits.empty': 'Ingen underenheter registrert.',
  'entity.accounts.empty': 'Ingen årsregnskap levert til Regnskapsregisteret.',
  'entity.accounts.latestOnly':
    'Brønnøysunds åpne API gir bare siste innsendte år. Tidligere år vises her etter hvert som Autho observerer dem.',
  'entity.accounts.period': 'Periode',
  'entity.accounts.inNok.rate':
    'Regnskapet til {period} er levert i {currency}; NOK ved hvert tall etter Norges Banks kurs for {date}: 1 {currency} = {rate}.',
  'entity.accounts.inNok.noRate':
    'Regnskapet til {period} er levert i {currency}. Ingen kurs: vist bare i {currency}.',
  'entity.accounts.revenue': 'Driftsinntekter',
  'entity.accounts.operatingResult': 'Driftsresultat',
  'entity.accounts.netResult': 'Årsresultat',
  'entity.accounts.totalAssets': 'Sum eiendeler',
  'entity.accounts.equity': 'Egenkapital',
  'common.yes': 'Ja',
  'common.no': 'Nei',
  'common.unknown': 'Ukjent',
  'common.cancel': 'Avbryt',
  'common.close': 'Lukk',
  'common.save': 'Lagre',
  'common.retry': 'Prøv igjen',
  'common.loadMore': 'Vis flere',
  'common.export': 'Eksporter',

  'confidence.stated': 'Oppgitt',
  'confidence.confirmed': 'Bekreftet',
  'confidence.extracted': 'Hentet',
  'confidence.inferred': 'Utledet',
  'confidence.stated.description': 'En person har registrert dette.',
  'confidence.confirmed.description': 'Hentet inn og deretter godkjent av en person.',
  'confidence.extracted.description': 'Lest fra en kildepost.',
  'confidence.inferred.description': 'Utledet av en modell. Bruk med varsomhet.',

  'provenance.title': 'Opprinnelse',
  'provenance.open': 'Vis opprinnelse',
  'provenance.provider': 'Kilde',
  'provenance.object': 'Kildeobjekt',
  'provenance.observedAt': 'Observert',
  'provenance.confidence': 'Pålitelighet',
  'provenance.lastVerified': 'Sist bekreftet',
  'provenance.override': 'Din overstyring',
  'provenance.override.none': 'Ingen overstyring',
  'provenance.derivation': 'Utledning',
  'provenance.provider.brreg': 'Brønnøysundregistrene',
  'provenance.provider.manual': 'Registrert i Autho',
  'provenance.provider.brreg.short': 'Brreg',
  'provenance.provider.manual.short': 'Manuell',
  'provenance.provider.google': 'Google',
  'provenance.provider.google.short': 'Google',
  'provenance.provider.icloud': 'iCloud',
  'provenance.provider.icloud.short': 'iCloud',

  'engine.key.title': 'Egen modellnøkkel',
  'engine.key.none': 'Ingen nøkkel. Authos egne modeller svarer, innenfor budsjettet over.',
  'engine.key.held':
    '{provider}-nøkkel, behandler i {where}, lagt inn {day}. Tak: {daily} per dag, {monthly} per måned.',
  'engine.key.where.us': 'USA',
  'engine.key.where.eu': 'Europa',
  'engine.key.eeaOnly':
    'Denne profilen holder KI-behandling i EØS, så her kan bare en OpenAI-nøkkel fra et prosjekt i Europa brukes.',
  'engine.key.notYetUsed': 'Ingenting kaller en modell med den ennå; Chat kommer til å gjøre det.',
  'engine.key.provider': 'Leverandør',
  'engine.key.provider.anthropic': 'Anthropic (API-nøkkel fra Console, behandler i USA)',
  'engine.key.provider.openai': 'OpenAI (prosjektnøkkel)',
  'engine.key.inEurope': 'Prosjektet ble opprettet med Europa som region',
  'engine.key.key': 'Nøkkel',
  'engine.key.dailyCap': 'Tak per dag (NOK)',
  'engine.key.monthlyCap': 'Tak per måned (NOK)',
  'engine.key.enter': 'Bekreft og lagre',
  'engine.key.sealed': 'Bekreftet hos leverandøren og forseglet. Den vises aldri igjen.',
  'engine.key.remove': 'Fjern nøkkel',
  'engine.key.removed':
    'Fjernet her og slettet fra Autho. Nøkkelen finnes fortsatt hos leverandøren: slett den der.',
  'engine.key.deleteAt': 'Slett den hos leverandøren',
  'engine.status.title': 'Status',
  'engine.status.processing': 'KI-behandling skjer i',
  'engine.status.processing.eea': 'Kun EØS',
  'engine.status.processing.any': 'Rimeligste modell som holder mål',
  'engine.status.storage': 'Opplysningene dine lagres i',
  'engine.status.storage.eea': 'EØS, uansett innstilling',
  'engine.status.ledgers': 'Regnskap koblet til',
  'engine.status.ledgers.none': 'Ingenting koblet til',
  'engine.status.ledgers.count':
    '{count, plural, one {# selskap} other {# selskaper}} · {currencies}',
  'engine.status.spend': 'Brukt i dag ({day})',
  'engine.status.spend.value': '{billed} av {limit}',
  'engine.status.documents': 'Dokumenter',
  'engine.status.documents.value':
    '{read} lest · {waiting} venter · {failed, plural, one {# uleselig} other {# uleselige}}',
  'engine.status.queue': 'Kø',
  'engine.status.queue.clear': 'Ingenting venter',
  'engine.status.queue.waiting':
    '{count, plural, one {# dokument venter} other {# dokumenter venter}}',
  'engine.status.reservations':
    'Mer enn en fjerdedel av dagens tak er holdt av kall som er underveis. Kjører ingenting, er det kall som har falt ut, og de frigis ved midnatt UTC.',
  'engine.status.budget': 'Ditt budsjett i dag ({day})',
  'engine.status.budget.value': '{billed} av {limit}',
  'engine.status.meter': 'Målt denne måneden ({month})',
  'engine.status.meter.value': '{billed}, av det Chat {chat}',
  'engine.status.sharedCeiling':
    'To grenser, og de er ikke samme tall. Authos dagstak er hva hele installasjonen kan bruke på en dag; ditt budsjett er hva Autho kan bruke på dine vegne av det. Er det ikke satt et eget budsjett for deg, er det dagstaket som gjelder.',
  'engine.runsOn.title': 'Hva Autho kjører på',
  'engine.runsOn.compute': 'Beregning',
  'engine.runsOn.compute.value': 'Google Cloud Run (Belgia), EU',
  'engine.runsOn.database': 'Database',
  'engine.runsOn.database.value': 'Supabase Postgres (Frankfurt), EU',
  'engine.runsOn.storage': 'Lagring',
  'engine.runsOn.storage.value': 'Supabase Storage (Frankfurt), EU',
  'engine.runsOn.intelligence': 'Intelligens',
  'engine.runsOn.intelligence.native.any':
    'Vertex AI hos Google Cloud, i en EU-region der modellen tilbys, og globalt bare der den ikke gjør det',
  'engine.runsOn.intelligence.native.eea': 'Vertex AI hos Google Cloud, bare i EØS',
  'engine.runsOn.intelligence.ownKey': 'Din egen API-nøkkel fra Anthropic eller OpenAI',
  'engine.runsOn.inUse': 'I bruk',
  'engine.runsOn.chat': 'Chats modeller, billigste først',
  'engine.runsOn.chat.tier': '{model} · {region}',
  'engine.runsOn.chat.start': 'Nye tråder starter her · {measured}',
  'engine.runsOn.chat.neverMeasured': 'aldri målt',
  'engine.runsOn.chat.measuredOn': 'målt på {run}',
  'engine.runsOn.notYet': 'Tilbys ikke ennå',
  'engine.runsOn.subscriptions': 'Abonnementer',
  'engine.runsOn.subscriptions.value':
    'Din egen assistent, som Claude eller ChatGPT, kan lese Autho på ditt eget abonnement.',
  'engine.runsOn.subscriptions.link': 'Koble den til under Tilgang',

  'nav.bank': 'Bank',
  'bank.title': 'Bank',
  'bank.description':
    'Saldoer lest direkte fra banker du har koblet til, og saldoer fra kontoutskrifter du har importert. Hvert tall viser datoen det gjelder per og når det ble lest.',
  'bank.import': 'Importer en kontoutskrift',
  'bank.import.explain':
    'En CAMT.053-fil fra nettbanken din. Ingenting sendes noe sted: den leses her og blir liggende i din egen leietaker.',
  'bank.import.choose': 'Velg en fil',
  'bank.import.reading': 'Leser den…',
  'bank.imported':
    'Leste {statements, plural, one {# kontoutskrift} other {# kontoutskrifter}}: {balances, plural, one {# saldo} other {# saldoer}} og {entries, plural, one {# postering} other {# posteringer}}.',
  'bank.imported.again': 'Autho hadde den filen fra før. Ingenting ble endret.',
  'bank.empty': 'Ingen kontoutskrift er importert ennå.',
  'bank.balance.closing': 'Utgående saldo',
  'bank.balance.opening': 'Inngående saldo',
  'bank.balance.available': 'Disponibelt',
  'bank.balance.forward': 'Disponibelt fremover',
  'bank.balance.interim': 'Foreløpig',
  'bank.asOf': 'per {date}',
  'bank.age': '{ago}',
  'bank.stale': 'Eldre enn en kontoutskriftsperiode. Det kan mangle en måned.',
  'bank.from': 'Fra {filename}, importert {when}',
  'bank.notLive':
    'Disse tallene kommer fra kontoutskriftene over, ikke fra en bank. Ingen bank er tilkoblet, så hvert tall gjelder per datoen på utskriften sin.',
  'bank.fromFiles':
    'Disse tallene kommer fra kontoutskriftsfiler, ikke fra sanntidsoversikten over. En fil gjelder per datoen på den; sanntidsoversikten leses når du åpner denne siden.',
  'bank.callback.title': 'Kobler til banken',
  'bank.callback.connected': 'Tilkoblet. Fullmakten omfatter {accounts} kontoer.',
  'bank.callback.declined': 'Bankfullmakten ble avvist. Ingenting ble lagret.',
  'bank.callback.incomplete':
    'Banken sendte nettleseren tilbake uten kode. Start på nytt fra Bank-siden.',
  'bank.validUntil': 'Gyldig til {date}.',
  'bank.live.title': 'Direktekobling',
  'bank.live.explain':
    'Kontoer besvart direkte fra banken under en fullmakt du har gitt. Saldoen leses når du åpner denne siden, og når en agent spør under en tilgang. Ingenting lagres: et tall her ble lest nå nettopp og tas ikke vare på.',
  'bank.live.empty': 'Ingen bank er tilkoblet ennå.',
  'bank.live.for': 'for {name}',
  'bank.account.unnamed': 'Konto',
  'bank.live.reading': 'leser saldoen…',
  'bank.live.noBooked': 'banken oppgav ingen bokført saldo for denne kontoen',
  'bank.live.readAt': 'lest kl. {time}',
  'bank.connect': 'Koble til bank',
  'bank.connect.entity': 'Hvilket selskaps kontoer',
  'bank.connect.bank': 'Bank',
  'bank.connect.start': 'Fortsett til banken',
  'bank.connect.noManaged': 'Ingen forvaltet enhet ennå. Legg til en under Struktur først.',
  'bank.connect.needsApp':
    'Lim inn applikasjons-id-en fra Enable Banking under Innstillinger → Leverandør-apper først.',
  'settings.providerApps.enablebanking': 'Enable Banking',
  'settings.providerApps.enablebanking.where':
    'Fra Enable Banking: Control Panel → Applications → applikasjonen din. Redirect-URL: https://autho.no/connect/bank/callback. Det finnes ingen hemmelighet å lime inn — signeringsnøkkelen er Authos egen.',
  'settings.providerApps.enablebanking.works':
    'Enable Banking svarte: denne registreringen virker ({name}). Ingenting er lest fra noen bank — det krever et samtykke, som starter på Bank-siden.',
  'settings.providerApps.enablebanking.refused':
    'Enable Banking avviste denne registreringen ({status}). Antingen er applikasjons-id-en ikke den de har, eller signeringsnøkkelen på denne serveren hører til en annen registrering. Ingenting annet i Autho kan virke før dette gjør det.',
  'settings.providerApps.enablebanking.noKey':
    'Lagret, men ikke sjekket: signeringsnøkkelen er ikke på denne serveren ennå, så det var ingenting å signere en forespørsel med. Den kommer med neste deploy.',
  'settings.providerApps.enablebanking.unreachable':
    'Lagret, men ikke sjekket: Enable Banking svarte ikke. Så langt Autho kan se er det ingenting galt med det du skrev.',
  'settings.providerApps.enablebanking.configured': 'Registrert som {clientId}.',
  'settings.providerApps.applicationId': 'Applikasjons-ID',
  'entity.section.books': 'Regnskap',
  'entity.books.explain':
    'En SAF-T Financial-eksport fra regnskapssystemet, lastet opp her. Den går inn i samme hovedbok som en direktekobling skriver til, så en korrigert eksport erstatter det som er endret og beholder resten. Hver opplasting sier hvilken periode den dekker.',
  'entity.books.choose': 'Last opp SAF-T-eksport',
  'entity.books.reading': 'Leser filen…',
  'entity.books.loaded':
    'Lastet inn: {accounts, plural, one {# konto} other {# kontoer}}, {vouchers, plural, one {# bilag} other {# bilag}}, {superseded, plural, one {# post erstattet} other {# poster erstattet}}.',
  'entity.books.again': 'Autho hadde allerede den filen. Ingenting ble endret.',
  'entity.books.empty': 'Ingen regnskap er lastet opp for dette selskapet.',
  'entity.books.covers': 'Dekker {from} – {to}',
  'entity.books.coversUnstated': 'Filen oppgir ingen periode',
  'entity.books.postingsTo': 'Posteringer til og med {date}',
  'entity.books.statedPeriod': 'Filen oppgir selv perioden {from} – {to}.',
  'entity.books.noPostings': 'Filen har ingen posteringer i den perioden.',
  'entity.books.uploaded': 'lastet opp {ago}',
  'entity.books.uploadedAgain': 'lastet opp igjen {ago}',
  'entity.books.from': 'Fra {software}, SAF-T {version}',
  'entity.books.coveredByConnected':
    'Dekket av det tilkoblede regnskapssystemet, som har disse årene i sin helhet. Filen er fortsatt lagret, og regnskapet for årene leses fra systemet.',
  'entity.books.taxCodesUnknown':
    '{codes, plural, one {# mva-kode} other {# mva-koder}} ble lastet inn med ukjent retning: Skatteetatens standardliste plasserer {codes, plural, one {den} other {dem}} ikke, så linjene beholder koden og ingenting ble antatt.',
  'entity.books.doesNotClose':
    'Dette regnskapet går ikke i null: året viser {result}, og {allocated} er ført ut på disponeringskontoene. Begge tallene er fra denne filen.',
  'entity.books.soFar': 'Hittil i {year}: {result}.',
  'entity.books.allocated.none': 'ingenting',
  'entity.books.filed.heading': 'Regnskapet mot innsendt årsregnskap for {year}',
  'entity.books.filed.agrees':
    'Stemmer med det innsendte årsregnskapet på kronen for {measures, plural, one {# post} other {# poster}}. Innsendingen er i hele kroner, så et tall under én krone unna stemmer.',
  'entity.books.filed.differs': 'Stemmer ikke med det innsendte årsregnskapet:',
  'entity.books.filed.difference':
    '{measure}: regnskapet {ours}, innsendt {filed}, {difference} i avvik.',
  'entity.books.filed.none':
    'Ingen årsregnskap er innsendt til Brønnøysund for {year} ennå, så det finnes ingenting å sammenligne dette regnskapet med.',
  'entity.books.filed.withheld':
    '{measures} kan ikke sammenlignes: {accounts} har en inngående balanse Autho ikke har lest, så regnskapet oppgir ingen sum for dem.',
  'entity.books.filed.fromYearEnd':
    'Autho har ingen posteringer for {year}, så året sammenlignes med saldoene ved årsslutt oppgitt {date}, uten posteringer bak dem.',
  'entity.books.filed.nothing':
    'Autho har ingen posteringer for {year} og ingen saldoer oppgitt ved årsslutt, så året sammenlignes ikke.',
  'entity.books.filed.missing':
    'Ikke sammenlignet, fordi tallene mangler: {measures}. Autho har ikke tall for {count, plural, one {den} other {dem}} for dette året, og et hull er ikke et avvik.',
  'entity.books.filed.measure.totalAssets': 'Sum eiendeler',
  'entity.books.filed.measure.equity': 'Egenkapital',
  'entity.books.filed.measure.netResult': 'Årsresultat',
  'entity.books.filed.measure.totalLiabilities': 'Sum gjeld',
  'entity.books.filed.measure.revenue': 'Driftsinntekter',
  'entity.books.filed.measure.operatingResult': 'Driftsresultat',
  'entity.books.filed.measureHeading': 'Post',
  'entity.books.filed.ours': 'Fra regnskapet',
  'entity.books.filed.theirs': 'Innsendt',
  'entity.books.filed.notStated': 'ikke oppgitt',
  'entity.books.standard.heading': 'Det samme regnskapet etter standardkontoplanen, {year}',
  'entity.books.standard.explain':
    'Bare en sammenligning. Summene er etter hver kontos eget nummer; denne kolonnen plasserer hver konto der SAF-T-filen tilordner den.',
  'entity.books.standard.own': 'Etter eget kontonummer',
  'entity.books.standard.byStandard': 'Etter standardkontoplanen',
  'entity.books.standard.account': 'Konto',
  'entity.books.standard.class': 'klasse {digit}',
  'entity.books.standard.mapped':
    'klasse {digit}, {from, select, grouping_code {grupperingskode} other {standardkonto}} {code}',
  'entity.books.standard.unmapped': 'ikke tilordnet',
  'entity.books.standard.placedElsewhere':
    '{count, plural, one {# konto er} other {# kontoer er}} plassert i en annen klasse etter filens tilordning enn etter {count, plural, one {sitt eget nummer} other {sine egne numre}}:',
  'entity.books.standard.samePlace':
    'Filens tilordning plasserer hver konto i samme klasse som kontoens eget nummer.',
  'entity.books.closes':
    'Dette regnskapet går i null: året viser {result}, og det samme beløpet er ført ut på disponeringskontoene. Begge tallene er fra denne filen.',
  'entity.books.result.profit': 'et overskudd på {amount}',
  'entity.books.result.loss': 'et underskudd på {amount}',
  'entity.books.result.none': 'verken overskudd eller underskudd',
  'entity.result.profit': 'overskudd {amount}',
  'entity.result.loss': 'underskudd {amount}',
  'entity.books.openingsUnread':
    'Balansen er ikke oppgitt: {files} ble lest av en tidligere versjon av SAF-T-leseren, som ikke leste inngående balanser. Last opp den samme filen igjen, så blir de lest.',
  'entity.books.rereading':
    'Balansen holdes tilbake mens {files} leses på nytt av den gjeldende versjonen av SAF-T-leseren. Autho tok vare på filen, så dette skjer av seg selv innen en time.',
  'entity.books.stoppedAgreeing.upload':
    'Regnskapet for {year} stemte med det innsendte årsregnskapet for {year} helt til {file} ble lastet opp {when}. Nå stemmer det ikke lenger: sammenligningen under viser hvor.',
  'entity.books.stoppedAgreeing.reread':
    'Regnskapet for {year} stemte med det innsendte årsregnskapet for {year} helt til {file} ble lest på nytt {when}. Nå stemmer det ikke lenger: sammenligningen under viser hvor.',
  'entity.books.stoppedAgreeing.unnamedFile': 'en fil',
  'entity.books.openingsRead':
    'Inngående balanse: {written, plural, one {# lest fra filen, og den stemmer} other {# lest fra filen, og alle stemmer}} med filens egen utgående balanse.',
  'entity.books.openingsDisagree':
    'Inngående balanse: {written, number} lest, og {count, plural, one {# konto stemmer} other {# kontoer stemmer}} ikke med filens egen utgående balanse — {accounts}. Regnskapet er lastet inn; tallene er filens egne.',
  'entity.books.openingsMidYear':
    'Denne filen starter midt i året, så balansene den oppgir gjelder filens egen startdato og ikke årets. De er kontrollert mot filens egen utgående balanse og ikke lagret som inngående balanse.',
  'entity.books.openingsPlacedMidYear':
    'Denne filen starter midt i året og er den første av selskapets regnskap, så balansene den oppgir ved start er ført som balansene per {on}. En fil som dekker månedene før, erstatter dem.',
  'entity.books.openingsMissing':
    'Ingen inngående balanse i denne filen for {accounts}. Summer som trenger dem vises ikke, framfor å vises som en bevegelse.',
  'entity.books.openingsLastYearsResult':
    '{count, plural, one {# resultatkonto åpner} other {# resultatkontoer åpner}} året med fjorårets avslutningstall ({accounts}). En resultatkonto starter hvert år på null, så {count, plural, one {den føres} other {de føres}} ikke inn i år, og regnes med i egenkapitalen til fjoråret er avsluttet.',
  'nav.inbox': 'Innboks',
  'inbox.title': 'Innboks',
  'inbox.description':
    'Det som har gått over fristen, det ingen har svart på, det du lovet, og hvem du har blitt stille overfor. Telt fra dine egne meldingshoder av regler — ingen modell leser e-posten din.',
  'inbox.empty': 'Ingenting venter på deg i dag.',
  'inbox.empty.explain':
    'Ingenting er over fristen, ingenting venter på svar, og ingen har blitt stille. Autho sier fra her når det endrer seg.',
  'inbox.empty.nothingConnected':
    'Ingenting er koblet til ennå, så det er ingenting å se på. Koble til en konto, så begynner Autho å si hva som venter på deg.',
  'inbox.connect': 'Koble til en konto',
  'inbox.kind.overdue': 'Over frist',
  'inbox.kind.unanswered_ask': 'Ubesvart',
  'inbox.kind.due_soon': 'Nær frist',
  'inbox.kind.promise_open': 'Du lovet',
  'inbox.kind.gone_quiet': 'Blitt stille',
  'inbox.days.overdue': '{days} dager over fristen',
  'inbox.days.today': 'frist i dag',
  'inbox.days.unanswered': 'spurt for {days} dager siden, ingenting skrevet tilbake',
  'inbox.days.due': 'frist {date}',
  'inbox.days.promise': 'lovet for {days} dager siden, fortsatt åpent',
  'inbox.days.quiet': 'sist hørt fra for {days} dager siden',
  'inbox.rule': 'reist av {rule}',
  'inbox.open': 'Åpne',
  'inbox.snooze': 'Ikke nå',
  'inbox.unsnooze': 'Si fra igjen',
  'inbox.snooze.explain':
    'Dette skjuler linjen i en måned. Det sier ingenting om personen: rytmen, opptellingen og alt annet står som før.',
  'inbox.empty.explain.snoozed':
    'Ingenting er over fristen og ingenting venter på svar. Den som har blitt stille, er satt på vent over.',
  'inbox.snoozed.one': '{name} har blitt stille og er satt på vent til {date}.',
  'inbox.howMade':
    'Hver linje her er en opptelling eller en dato: ingen har skrevet tilbake, fristen har gått, dette er dobbelt så lenge som vanlig. Om et løfte ble holdt, står i meldingen selv, som Autho ikke har.',
  // *Eldre* (F516): det som har stått på listen i mer enn en måned, tatt vare på og ett trykk fra dagens liste.
  'inbox.view': 'Hvilke linjer',
  'inbox.view.today': 'I dag',
  'inbox.view.older': 'Eldre',
  'inbox.older.explain':
    'Linjer som har stått på listen i mer enn {days} dager. Ingenting ved dem er endret: hver er tatt vare på, kan finnes her og kommer tilbake på dagens liste med ett trykk.',
  'inbox.older.search': 'Søk i eldre linjer',
  'inbox.older.empty': 'Ingenting har stått lenge nok på listen til å havne her.',
  'inbox.older.noMatch': 'Ingen eldre linje passer.',
  'inbox.older.bringBack': 'Hent tilbake',
  'inbox.older.bringBack.explain':
    'Setter linjen tilbake på dagens liste i {days} dager til. Ingenting annet endres.',
  'inbox.older.note':
    'En linje som har stått på listen i mer enn {days} dager, flyttes av seg selv til Eldre, der den er tatt vare på og kan hentes tilbake.',
  'nav.relationships': 'Relasjoner',
  'relationships.title': 'Relasjoner',
  'relationships.description':
    'Menneskene i e-posten og kalenderen din, telt fra hodene: hvem som skrev, hvem som ble invitert, hvor ofte, når sist. Ingen modell leser e-posten din, og ingenting slås opp andre steder.',
  'relationships.search': 'Finn en person eller en organisasjon',
  'relationships.empty': 'Ingen ennå. Folk dukker opp her når en tilkoblet konto er lest.',
  'relationships.person.counts': '{from} fra dem · {to} til dem · {meetings} møter',
  'relationships.person.cadence': 'omtrent hver {days}. dag',
  'relationships.person.lastSeen': 'sist {date}',
  'relationships.person.basis': 'fra {count} meldingshoder',
  'relationships.person.strength': 'Styrken på relasjonen, fra antall og datoer',
  'relationships.commitments': 'Forpliktelser',
  'relationships.commitments.explain':
    'Det en emnelinje eller en invitasjon sier er avtalt. Typen, retningen og en dato der en er skrevet — hva som faktisk ble avtalt, står i meldingen, som Autho ikke har.',
  'relationships.commitments.empty': 'Ingenting åpent.',
  'relationships.kind.meeting': 'Møte',
  'relationships.kind.ask': 'Spurt om',
  'relationships.kind.promise': 'Du lovet',
  'relationships.kind.payment_due': 'Betaling forfaller',
  'relationships.direction.mine': 'ditt å gjøre',
  'relationships.direction.theirs': 'deres å gjøre',
  'relationships.due': 'frist {date}',
  'relationships.undated': 'ingen dato skrevet',
  'relationships.rule': 'lest av regelen «{rule}»',
  'relationships.done': 'Gjort',
  // Samme ord som Oppfatninger bruker om samme handling, på begge språk (O50).
  'relationships.forget': 'Glem',
  'relationships.forgotten': 'Glemt',
  'relationships.forgetIsNotErase':
    'Å glemme stopper bruken av en forpliktelse, på alle tidspunkter. Det skriver ikke om historien: raden blir stående, og det gjør sporet også.',
  'relationships.showForgotten': 'Vis glemte',
  'relationships.people.recomputed':
    'Ingenting her korrigeres: hvert tall er en opptelling, regnet ut på nytt fra meldingshodene etter hver synkronisering. Det som kan glemmes, er en forpliktelse.',
  'relationships.proposals': 'Kanskje samme person ({count})',
  'relationships.proposals.explain':
    'Kort med samme fulle navn. Autho slår aldri sammen to adresser på egen hånd: si om hvert par er én person.',
  'relationships.proposals.pair': '{a} og {b}',
  'relationships.proposals.mergeAll': 'Samme person, alle {count}',
  'relationships.samePerson': 'Samme person',
  'relationships.notSame': 'Ikke samme',
  'relationships.notThisPerson': 'Ikke denne personen',
  'relationships.notThisPerson.label': '{email} er ikke denne personen',
  'relationships.how':
    'Alt på denne skjermen er telt fra meldingshoder av regler — en adresse, et navn, en dato, en emnelinje. Ingenting her er lest fra en meldingstekst, og ingen modell er spurt.',
  'nav.conversations': 'Samtaler',
  'nav.calendar': 'Kalender',
  'nav.files': 'Filer',
  'record.conversations.title': 'Samtaler',
  'record.conversations.description':
    'E-posten Autho har, nyeste først: hvem som sendte den, emnet, datoen og utdraget leverandøren gir.',
  'record.calendar.title': 'Kalender',
  'record.calendar.description':
    'Alle hendelser Autho har, fra alle kalenderne du har koblet til, i én liste: i dag og det som kommer først, deretter det som har vært.',
  'record.calendar.earlier': 'Før i dag',
  'record.files.title': 'Filer',
  'record.files.description':
    'Filene Autho vet om, nyeste først. Autho har en peker til hver fil, aldri selve filen.',
  'record.fedBy': 'Mates av',
  'record.fedBy.manage': 'Administrer under Kilder',
  'record.fedBy.paused': 'Satt på pause',
  'record.fedBy.notApproved': 'Første lesing er ikke godkjent ennå',
  'record.connect.mail': 'Koble til Google-e-post',
  'record.connect.calendar': 'Koble til en Google-kalender',
  'record.connect.drive': 'Koble til Google Disk',
  'record.icloud': 'iCloud kobles til under Kilder, med et appspesifikt passord.',
  'record.icloudDrive':
    'iCloud Drive kan ikke kobles til: Apple gir ingen andre tjenester mulighet til å lese den.',
  'record.conversations.unfed':
    'Ingenting mater Samtaler ennå. Koble til en e-postkonto, så vises e-posten her.',
  'record.calendar.unfed':
    'Ingenting mater Kalender ennå. Koble til en kalender, så vises hendelsene her.',
  'record.files.unfed': 'Ingenting mater Filer ennå. Koble til Google Disk, så vises filene her.',
  'record.empty.unread':
    'Ingenting her ennå: en konto er koblet til, men første lesing er ikke godkjent. Godkjenn den under Kilder.',
  'record.empty.nothing': 'Ingenting her ennå fra kontoene som mater denne siden.',
  'record.account': 'Konto',
  'record.account.all': 'Alle kontoer',
  'record.column.when': 'Dato',
  'record.column.from': 'Fra',
  'record.column.subject': 'Emne',
  'record.column.event': 'Hendelse',
  'record.column.organizer': 'Arrangør',
  'record.column.name': 'Navn',
  'record.column.type': 'Type',
  'record.column.account': 'Konto',
  'record.column.open': 'Hos leverandøren',
  'record.allDay': 'Hele dagen',
  'record.noSubject': '(uten emne)',
  'record.untitled': '(uten navn)',
  'record.open': 'Åpne hos {provider}',
  'record.more': 'Vis flere',
  'record.file.document': 'Dokument',
  'record.file.spreadsheet': 'Regneark',
  'record.file.presentation': 'Presentasjon',
  'record.file.pdf': 'PDF',
  'record.file.image': 'Bilde',
  'record.file.folder': 'Mappe',
  'record.file.other': 'Fil',
  'record.how.mail':
    'Her vises bare avsender, emne, dato og utdraget leverandøren gir. Selve meldingen åpnes hos leverandøren.',
  'record.how.calendar':
    'Lest fra kalenderne dine slik de var ved siste lesing; ingenting her skrives noen gang tilbake til en kalender.',
  'record.how.drive':
    'Autho har navnet, typen og datoen til hver fil og hvor den ligger; filen åpnes hos leverandøren.',
  'accounts.reading.started': 'Leser denne kontoen nå. Det fortsetter i bakgrunnen.',
  'accounts.reading.soFar':
    'Leser denne kontoen nå — {held} funnet så langt. Det fortsetter i bakgrunnen; du kan forlate siden.',
  'accounts.reading.ofAbout': '{held} av omtrent {expected} lest — {percent} % av veien.',
  'accounts.reading.ofAboutLeft':
    '{held} av omtrent {expected} lest — {percent} % av veien, omtrent {minutes} min igjen.',
  'accounts.reading.stalled':
    'Stanset siden {when}. Ingenting er lest siden da. Autho prøver på nytt hver time, og jeg får beskjed når en lesing stopper; ingenting går tapt, og ingenting belastes to ganger når den starter igjen.',
  'accounts.held': '{held} ting er hentet fra denne kontoen.',
  'accounts.revokeFailed':
    'Autho fikk ikke trukket tilbake tilgangen sin hos {provider}, så den kan fortsatt være aktiv der. Fjern Autho under integrasjonene i {provider}-innstillingene dine.',
  // Flytting av en personlig konto ut av en bedrifts profil (R2; D87, D92). Se kommentaren i `en.ts`.
  'accounts.move.title': 'Flytt til din personlige profil',
  'accounts.move.explain':
    'Dette er en personlig konto i en bedrifts profil. Når du flytter den, kopierer Autho den til din personlige profil med alt du har bestemt om den, sjekker at den kan leses der, og først da kan du fjerne den her. Ingenting trekkes tilbake hos {provider}.',
  'accounts.move.stage.notStarted': 'Ikke flyttet ennå.',
  'accounts.move.stage.interrupted':
    'En flytting stoppet før den var ferdig. Fortsett den, eller avbryt den.',
  'accounts.move.stage.copying':
    'Kopierer til din personlige profil: {held} av {total} så langt. Fortsett for å kopiere resten. Ingenting er fjernet her.',
  'accounts.move.stage.copied':
    'Kopiert til din personlige profil, men Autho har ennå ikke lest kontoen der. Ingenting er fjernet her.',
  'accounts.move.stage.waiting':
    'Kopiert og lest i din personlige profil. Venter på at {agents} leser den der før denne kopien kan fjernes.',
  'accounts.move.stage.ready':
    'Kopiert og lest i din personlige profil. Nå kan du fjerne den fra bedriftens profil.',
  'accounts.move.stage.already':
    'Din personlige profil har allerede denne kontoen, koblet til der. Når du flytter den, legger Autho til det bedriftens kopi vet som tilkoblingen der ikke vet, og beholder alt som er dens eget: det den har lest, det du har bestemt der, og godkjenningen. Deretter kan du fjerne den her. Ingenting trekkes tilbake hos {provider}.',
  'accounts.move.stage.done': 'Flyttet til din personlige profil {when}.',
  'accounts.move.access': 'Settes også opp i din personlige profil:',
  'accounts.move.access.item': '{agent} kan lese {resources} til {when} – «{purpose}»',
  'accounts.move.access.none':
    'Ingen agent leser denne kontoen her, så det er ingen tilgang å sette opp.',
  'accounts.move.counted':
    'Telt i begge profilene: {items} elementer, {calendars} kalendere, {addresses} adresser.',
  'accounts.move.start': 'Flytt til min personlige profil',
  'accounts.move.continue': 'Fortsett flyttingen',
  'accounts.move.working': 'Flytter… dette kan ta noen minutter.',
  'accounts.move.finish': 'Fjern den fra bedriften',
  'accounts.move.finish.explain':
    'Dette fjerner bedriftens kopi og alt som er lest inn i den her. Kopien i din personlige profil blir værende, og ingenting trekkes tilbake hos {provider}.',
  'accounts.move.finish.confirm': 'Ja, fjern den her',
  'accounts.move.cancel': 'Avbryt flyttingen',
  'accounts.move.stopped.incomplete':
    'Det var mer enn ett trykk rekker å kopiere. Alt som er kopiert så langt, beholdes; fortsett for å kopiere videre derfra.',
  'accounts.move.stopped.counts':
    'Kopien stemte ikke da den ble telt, så ingenting er fjernet. Fortsett for å kopiere den på nytt.',
  'accounts.move.stopped.inconclusive':
    'Tellingen fikk ikke se kontoen i begge profilene, så ingenting er fjernet. Fortsett for å prøve igjen.',
  'accounts.move.stopped.proof':
    'Autho fikk ikke lest kontoen med kopien i din personlige profil, så ingenting er fjernet. Fortsett for å prøve igjen.',
  'accounts.move.blocked.handshake':
    'En tilkobling pågår i denne profilen akkurat nå. Prøv igjen om noen minutter.',
  'accounts.move.blocked.failing':
    'Autho får ikke lest kontoen med kopien i din personlige profil akkurat nå, så denne kopien blir værende til det går.',
  // F352. Se kommentaren i `en.ts`.
  'accounts.move.blocked.inAnotherCompany':
    'Denne kontoen hører til mer enn ett av selskapene dine: Den er også koblet til i et annet, eller den ble flyttet til den personlige profilen din fra et annet. Den kan ikke flyttes herfra ennå.',
  // Et trykk serveren avviste, etter koden (F336). Se kommentaren i `en.ts`.
  'accounts.move.refused.notAnOrg':
    'Bare en personlig konto i en bedrifts profil kan flyttes til en personlig profil.',
  'accounts.move.refused.notPersonal':
    'Bare Google- og iCloud-kontoer er personlige. Denne tilkoblingen er bedriftens egen og blir her.',
  'accounts.move.refused.notYours':
    'Bare den som koblet til denne kontoen, kan flytte den, fordi den flyttes til vedkommendes egen profil.',
  'accounts.move.refused.notLive':
    'Denne kontoen er ikke lenger koblet til her, så det er ingenting å flytte.',
  'accounts.move.refused.noIdentity':
    'Ingenting identifiserer kontoen bak denne tilkoblingen, så den kan ikke finnes igjen i din personlige profil.',
  'accounts.move.refused.noCredential':
    'Denne tilkoblingen har ingen lagret nøkkel, så en kopi ville aldri kunne lese kontoen. Koble den til i din personlige profil i stedet.',
  'accounts.move.refused.alreadyInPersonal':
    'Din personlige profil har allerede denne kontoen i en tilkobling som ikke lenger er aktiv der, og det som ble lest der, er tatt vare på. Koble den til på nytt i din personlige profil, så legger flyttingen til i den tilkoblingen, eller glem den der først.',
  'accounts.move.refused.alreadyProven':
    'Kopien i din personlige profil er allerede lest, så den kopieres ikke over på nytt.',
  'accounts.move.refused.handshakeOpen':
    'En tilkobling til denne leverandøren pågår i denne profilen akkurat nå. Vent noen minutter og prøv igjen.',
  'accounts.move.refused.accessChanged':
    'Hvilke agenter som leser denne kontoen, har endret seg siden siden ble lastet. Se på listen igjen og trykk én gang til.',
  'accounts.move.refused.notStarted':
    'Det finnes ingen kopi i din personlige profil for denne flyttingen: ingenting er kopiert ennå, eller flyttingen ble avbrutt. Ingenting er fjernet her.',
  'accounts.move.refused.notProven':
    'Autho har ennå ikke lest kontoen med kopien i din personlige profil, så denne kopien kan ikke fjernes.',
  'accounts.move.refused.waitingForAgent':
    'En agent som leser denne kontoen her, har ennå ikke lest den i din personlige profil, så denne kopien kan ikke fjernes.',
  'accounts.move.refused.personalFailing':
    'Autho får ikke lest kontoen med kopien i din personlige profil akkurat nå, så denne kopien kan ikke fjernes.',
  'accounts.move.refused.noOtherCopy':
    'Ingen annen kopi av denne kontoen er koblet til, så å fjerne denne ville fjerne den eneste.',
  'accounts.move.refused.alreadyFinished':
    'Flyttingen er allerede fullført, så det er ingenting igjen å avbryte. Kontoen ligger i din personlige profil.',
  'accounts.move.refused.nothingToCancel': 'Det er ingen flytting i gang som kan avbrytes.',
  'accounts.move.refused.inAnotherCompany':
    'Denne kontoen hører til mer enn ett av selskapene dine, så den kan ikke flyttes herfra ennå. Ingenting er endret.',
  // Se kommentaren i `en.ts`: ordene beskriver hva som skjer med *hendelsene*, ikke med kalenderen.
  'accounts.todoist': 'Varsler til listen din',
  'accounts.todoist.explain':
    'Når noe går galt — en lesing som feiler, en deploy som feiler — legger Autho én oppgave i din Todoist. Tilgangen lar Autho bare legge til oppgaver: Autho kan ikke lese, fullføre eller slette noe der, og et videre token avvises og trekkes tilbake på stedet.',
  'accounts.todoist.connect': 'Koble til Todoist',
  'todoist.callback.title': 'Kobler til Todoist',
  'todoist.callback.connected':
    'Tilkoblet. Autho kan legge en oppgave i listen din, og ikke noe annet. Første reelle hendelse blir én oppgave; en gjentakelse av samme hendelse blir ikke en nummer to.',
  'todoist.callback.tooWide':
    'Todoist ga tilbake et token som kan lese, når Autho bare ba om å legge til oppgaver. Ingenting ble lagret. Det er ingenting du kan endre hos Todoist — omfanget følger lenken Autho sender, så dette er Authos å rette.',
  'todoist.callback.unverified':
    'Autho fikk ikke slått fast hva dette tokenet kan gjøre: sjekken svarte {status}. Ingenting ble lagret, for et token Autho ikke kan gå god for, beholdes ikke.',
  'todoist.callback.unverifiedSilent':
    'Autho fikk ikke slått fast hva dette tokenet kan gjøre: sjekken fikk ikke svar i det hele tatt. Ingenting ble lagret, for et token Autho ikke kan gå god for, beholdes ikke.',
  'todoist.callback.notRevoked':
    'Autho fikk ikke trukket tilbake tokenet hos Todoist. Fjern Autho der selv: Settings → Integrations → Connected apps.',
  'todoist.callback.unproven':
    'Tilkoblet, men den første oppgaven kunne ikke legges inn, så veien er ikke bevist ennå. Det er ingenting galt med selve tilkoblingen — Autho prøver igjen neste gang noe trenger deg, og dette er skrevet i revisjonsloggen.',
  'todoist.callback.declined':
    'Ingenting ble koblet til. Du kan prøve igjen fra Tilkoblede kontoer.',
  'accounts.calendars': 'Kalendere i denne kontoen',
  'accounts.calendars.explain':
    'En konto lister hver kalender du noen gang har abonnert på, inkludert andres. Autho leser din egen kalender i sin helhet, og fra de andre bare hendelsene du selv er med på. Endre hvilken som helst av dem her.',
  'accounts.calendars.none':
    'Ingen kalendere er listet ennå. De kommer frem første gang Autho leser kalenderen til denne kontoen.',
  'accounts.calendars.primary': 'Din egen kalender',
  'accounts.calendars.choice.read': 'Alt i den',
  'accounts.calendars.choice.attendees': 'Bare hendelser jeg er med på',
  'accounts.calendars.choice.ignore': 'Ingenting',
  'accounts.calendars.default': 'Ikke valgt — Autho gjør dette som standard',
  'accounts.calendars.decided': 'Du valgte dette {when}',
  'accounts.calendars.show': 'Kalendere ({count})',
  // Se kommentaren i `en.ts`.
  'accounts.calendars.saving': 'Lagrer…',
  'accounts.calendars.savedNote': 'Lagret',
  'accounts.calendars.applying': 'Tar det i bruk på det som alt er lagret…',
  'accounts.calendars.failed':
    'Lagringen feilet, så det lagrede valget vises igjen. Prøv en gang til.',
  'accounts.calendars.hide': 'Skjul kalendere',
  // Se kommentaren i `en.ts`.
  'accounts.addresses.show': 'Dine adresser ({count})',
  'accounts.addresses.hide': 'Skjul adresser',
  'accounts.addresses': 'Hvilke adresser er deg?',
  'accounts.addresses.explain':
    'Autho regner en hendelse som din når en av disse adressene er med på den. Adressen denne kontoen logger inn med, er alltid deg. Legg til andre adresser du blir invitert med — for eksempel en jobbadresse på et annet domene.',
  'accounts.addresses.account': 'Denne kontoen — alltid deg',
  'accounts.addresses.suggested':
    'Sett på en kalender i denne kontoen. Autho regner den ikke som deg før du sier det.',
  'accounts.addresses.yes': 'Ja, det er meg',
  'accounts.addresses.no': 'Ikke meg',
  'accounts.addresses.notMine': 'Du sa at dette ikke er deg',
  'accounts.addresses.none': 'Ingen andre adresser ennå.',
  'accounts.addresses.add': 'Legg til',
  'accounts.addresses.failed':
    'Svaret ble ikke lagret, så adressen står der den sto. Prøv en gang til.',
  'accounts.addresses.addLabel': 'En annen adresse du blir invitert med',
  'signInWithAutho.title': 'Logg inn med Autho',
  'signInWithAutho.asks': '{name} vil logge deg inn med Autho-kontoen din.',
  'signInWithAutho.gets':
    'Appen får en ID for deg som bare denne appen får, og ingenting annet: ingen av dataene dine, og ingen vei inn i noen profil.',
  'signInWithAutho.every': 'Autho spør hver gang, og fører det i loggen i Personlig-profilen din.',
  'signInWithAutho.again': '{name} ber deg logge inn i Autho på nytt først.',
  'signInWithAutho.signInAgain': 'Logg inn på nytt',
  'signInWithAutho.allow': 'Logg inn',
  'signInWithAutho.deny': 'Ikke logg inn',
  'signInWithAutho.gone':
    'Denne innloggingen er avsluttet, eller ble startet i en annen nettleser. Start den på nytt fra appen.',
  'signInWithAutho.failed': 'Det gikk ikke. Start innloggingen på nytt fra appen.',
  // Se kommentaren i `en.ts`: navnelinjen er den bærende.
  'connectAgent.title': 'Koble til en assistent',
  'connectAgent.description':
    'Et program ber om å få lese det agentene dine kan lese — i den personlige profilen din, i ett selskap eller i begge. Ingenting kobles til før du godkjenner.',
  'connectAgent.broken':
    'Forespørselen er ufullstendig ({missing}), så det finnes ikke noe trygt å godkjenne. Lukk denne siden og start på nytt fra programmet som sendte deg hit.',
  'connectAgent.redirectRefused':
    'Programmet ba om å få svaret til en adresse det aldri har registrert. Det er slik avlytting ser ut, så Autho svarer ikke i det hele tatt.',
  'connectAgent.asks': '{name} ber om å koble til.',
  'connectAgent.nameIsAClaim':
    'Navnet er det programmet sa om seg selv — Autho kan ikke bekrefte det. Ventet du ikke dette, velg Avslå.',
  'connectAgent.codeGoesTo': 'Godkjenner du, sendes påloggingskoden til',
  'connectAgent.hostIsAFact':
    'Navnet over er en påstand. Denne adressen er ikke det: Autho avviser enhver adresse programmet ikke har registrert.',
  'connectAgent.choose': 'Hvilken agent, i hvilken profil?',
  'connectAgent.grantsRule':
    'I hver profil får programmet nøyaktig det agenten du velger der har — tilgangene dens, bestemt på Agenter-skjermen i den profilen. Å godkjenne her gir ingenting nytt.',
  'connectAgent.none': 'Ingen — ingenting fra denne profilen',
  'connectAgent.oneCompany':
    'Ett selskap per tilkobling. Velger du en agent i ett selskap, fjernes valget i de andre.',
  'connectAgent.notAdmin':
    'Bare en eier eller administrator av denne profilen kan koble til agentene der.',
  'connectAgent.noAgents':
    'Ingen agent her ennå. Opprett en på Agenter-skjermen i denne profilen og gi den en tilgang først.',
  'connectAgent.chooseOne': 'Velg en agent i minst én profil, eller avslå.',
  'connectAgent.approve': 'Godkjenn',
  'connectAgent.deny': 'Avslå',
  'nav.sources': 'Kilder',
  'accounts.title': 'Kilder',
  'accounts.description':
    'Alt Autho leser fra, én rad hver: hva den mater, hva den kan lese, og når den sist gjorde det.',
  'sources.feeds': 'Mater: {feeds}',
  'sources.feeds.none': 'Mater ingenting i Sinn',
  'sources.feed.structure': 'Struktur',
  'sources.feed.books': 'Regnskap',
  'sources.feed.bank': 'Bank',
  'sources.feed.conversations': 'Samtaler',
  'sources.feed.calendar': 'Kalender',
  'sources.feed.files': 'Filer',
  'sources.feed.relationships': 'Relasjoner',
  'sources.feed.alerts': 'Varsler, sendt og aldri lest',
  'sources.feed.goals': 'Mål, lest når du åpner dem',
  'sources.paused': 'Satt på pause siden {when}',
  'sources.pause': 'Sett på pause',
  'sources.resume': 'Fortsett',
  'sources.pause.explain': 'Autho slutter å lese; ingenting endres hos leverandøren.',
  'sources.resume.explain': 'Når du fortsetter, leser Autho videre fra der den stoppet.',
  'sources.others': 'Registre',
  'sources.pausedHere':
    'En kilde til denne siden er satt på pause, så ingenting nytt kommer hit før den fortsetter under Kilder.',
  'accounts.connect': 'Koble til en Google-konto',
  'accounts.connect.explain':
    'Én ting om gangen, så du ser hva du sier ja til. Kun lesing: Autho kan aldri sende, endre eller slette noe.',
  'accounts.surface.mail': 'E-post',
  'accounts.surface.calendar': 'Kalender',
  'accounts.surface.drive': 'Filer',
  'accounts.surface.contacts': 'Kontakter',
  'card.description':
    'Én person: hva e-posten og kontaktene dine sier om dem, og hva de er en del av.',
  'card.back': 'Alle relasjoner',
  'card.who': 'Hvem',
  'card.untitled': '(uten tittel)',
  'card.contact': 'Fra kontaktene dine',
  'card.contact.notConnected': 'Kontaktene dine er ikke koblet til. Koble dem til fra Relasjoner.',
  'card.contact.failed': 'Kontaktene dine kunne ikke leses akkurat nå. Ingenting er endret.',
  'card.contact.none': 'Ikke blant kontaktene dine.',
  'card.contact.source': 'Fra Google-kontakter, lest akkurat nå',
  'card.goals': 'Mål',
  'card.goals.none': 'Ingen mål er koblet til noe med denne personen.',
  'card.commitments': 'Forpliktelser',
  'card.commitments.none': 'Ingenting åpent nevner denne personen.',
  'card.events.none': 'Ingen hendelser med denne personen.',
  'card.conversations.none': 'Ingen e-post med denne personen.',
  'relationships.contacts': 'Blant kontaktene dine, ingen samtale ennå',
  'relationships.contacts.explain':
    'Lest fra Google-kontaktene dine når denne siden åpnes, og aldri lagret. En kontakt beriker personen den deler en adresse med; en som ikke deler noen, står her, og blir aldri gjort til en person.',
  'relationships.contacts.notOffered':
    'Google-kontakter kan ikke kobles til ennå: de venter på å bli lagt til Authos samtykkeskjerm hos Google. Personene her kommer fra e-post og kalender så lenge.',
  'relationships.contacts.notConnected': 'Kontaktene dine er ikke koblet til.',
  'relationships.contacts.connect': 'Koble til Google-kontakter',
  'relationships.contacts.failed':
    'Kontaktene dine kunne ikke leses akkurat nå. Ingenting er endret.',
  'relationships.contacts.none': 'Alle i kontaktene dine er noen du har skrevet med.',
  'accounts.empty': 'Ingenting koblet til ennå.',
  'accounts.personalElsewhere':
    'Google- og iCloud-kontoer er personlige, og kobles til i din egen profil, Personlig.',
  'accounts.state.active': 'Aktiv',
  'accounts.state.expiring': 'Utløper',
  'accounts.state.stale': 'Må kobles til på nytt',
  'accounts.state.revoked': 'Frakoblet',
  'accounts.state.forgotten': 'Glemt',
  'accounts.forgotten.tombstone':
    'En {provider}-konto var koblet til her, og alt Autho hadde lest fra den ble slettet {when}. Ingenting av den er igjen; denne linjen står igjen fordi revisjonsloggen viser til den.',
  'accounts.lastSync': 'Sist lest {when}',
  'accounts.never': 'aldri',
  'accounts.scope.calendar': 'lese kalenderen din',
  'accounts.scope.contacts': 'lese kontaktene dine',
  'accounts.scope.drive': 'lese filene dine i Drive',
  'accounts.scope.email': 'se e-postadressen din',
  'accounts.scope.identity': 'bekrefte hvem du er',
  'accounts.scope.mail': 'lese e-posten din',
  'accounts.scope.tasksAdd': 'legge til oppgaver i listen din',
  'accounts.scope.tasksRead': 'lese oppgavene dine',
  'accounts.scopes': 'Autho kan {scopes}.',
  'accounts.scopes.none': 'Ingenting gitt tilgang til ennå.',
  'accounts.expiring.note':
    'Tilgangen tar slutt {when}. Koble til på nytt før det, så stopper ingenting.',
  'accounts.stale.note': 'Autho får ikke lest denne kontoen. Ingenting er lest siden den stoppet.',
  'accounts.reconnect': 'Koble til på nytt',
  'accounts.disconnect': 'Koble fra',
  'accounts.disconnect.title': 'Koble fra denne kontoen?',
  'accounts.disconnect.explain':
    'Autho sletter tilgangen sin og slutter å lese. Er kontoen ikke koblet til andre steder, trekker Autho også tillatelsen tilbake hos Google.',
  'accounts.basis': 'Hvorfor (lagres i loggen)',
  'accounts.disconnect.confirm': 'Koble fra',
  'accounts.cancel': 'Avbryt',
  'accounts.icloud': 'Koble til en iCloud-konto',
  'accounts.icloud.explain':
    'Apple tilbyr ingen innlogging for E-post og Kalender, så dette krever et app-spesifikt passord. Lag ett på appleid.apple.com under Pålogging og sikkerhet, og lim det inn her. Autho lagrer det kryptert og viser det aldri igjen.',
  'accounts.icloud.address': 'iCloud-e-postadressen din',
  'accounts.icloud.password': 'App-spesifikt passord',
  'accounts.icloud.connect': 'Koble til',
  'accounts.icloud.checking': 'Sjekker det hos Apple…',
  'accounts.icloud.refused.mail':
    'Apple avviste passordet for E-post. Sjekk adressen, og lag et nytt passord hvis du er usikker.',
  'accounts.icloud.refused.calendar':
    'Apple godtok passordet for E-post, men avviste det for Kalender. Lag et nytt og prøv igjen.',
  'accounts.icloud.contacts': 'Les også Kontakter (navn og adresser, til hvem-er-hvem)',
  'accounts.icloud.contacts.works':
    'Kontakter svarte: {books} adressebok/-bøker, {cards} kort. Lesingen starter med en utgivelse bare du kan rulle ut.',
  'accounts.icloud.connected': 'Tilkoblet. E-post og kalender kan leses.',
  'accounts.icloud.noDrive':
    'iCloud Drive er ikke med: Apple tilbyr ingen måte for et annet program å lese den på.',
  'accounts.icloud.withdraw':
    'Å koble fra sletter passordet Autho har. Apple har ingen måte Autho kan trekke det tilbake på, så trekk det tilbake selv på appleid.apple.com for å stoppe det andre steder.',
  'accounts.notRead': 'Ingenting er lest fra denne kontoen ennå.',
  'accounts.estimate': 'Hva vil den første lesingen koste?',
  'accounts.estimate.counting': 'Teller hva som ligger der…',
  'accounts.estimate.items': 'Omtrent {items} ting å lese, på rundt {chars} tegn hver.',
  'accounts.estimate.atLeast':
    'Minst så mange: Kalender og Filer oppgir ikke hvor mange det er totalt, så det virkelige tallet kan være høyere.',
  'accounts.estimate.cost': 'Anslått kostnad: {nok}.',
  'accounts.estimate.budget': '{remaining} igjen av dagens {limit}.',
  'accounts.estimate.inherited':
    'Du har ikke noe eget budsjett satt, så Authos daglige grense for hele installasjonen er det som gjelder.',
  'accounts.estimate.wouldDefer':
    'Det er mer enn dagens budsjett tillater, så Autho leser det over flere dager i stedet for å stoppe.',
  'accounts.estimate.surface': '{surface}: {items}',
  'accounts.start': 'Begynn å lese',
  'accounts.started': 'Lesingen starter ved neste synkronisering.',
  'accounts.forget': 'Slett også alt Autho har lest fra denne kontoen',
  'accounts.forget.explain':
    'Meldingene, hendelsene og filene Autho har en peker til, og det den har lært av dem. Dette kan ikke angres. Å bare koble fra stopper lesingen og beholder det som allerede er lest.',
  'accounts.forgotten': 'Slettet {items} ting Autho hadde lest fra denne kontoen.',
  'accounts.disconnected': 'Frakoblet. Det Autho allerede har lest, ligger her fortsatt.',

  'connect.title': 'Kobler til',
  'connect.done': 'Tilkoblet. Autho begynner å lese ved neste synkronisering.',
  'connect.back': 'Tilbake til tilkoblede kontoer',
  'connect.declined': 'Ingenting ble koblet til, og ingenting ble endret.',
  'connect.lost':
    'Dette ble ikke fullført — innloggingen tok slutt mens du var på Googles side. Ingenting ble koblet til. Start på nytt, det tar et øyeblikk.',
  'connect.outcome.replayed':
    'Den lenken var allerede brukt. Ingenting ble koblet til — start på nytt.',
  'connect.outcome.expired':
    'Dette tok så lang tid at lenken gikk ut. Ingenting ble koblet til — start på nytt.',
  'connect.outcome.unknownState':
    'Dette kom ikke fra en tilkobling Autho startet, så ingenting ble koblet til.',
  'connect.outcome.wrongPerson':
    'Den tilkoblingen ble startet av en annen som er logget inn på denne maskinen. Ingenting ble koblet til.',
  'connect.outcome.missingScopes':
    'Autho trenger fortsatt tilgang til: {detail}. Start på nytt, og la avkrysningene stå.',
  'connect.outcome.differentAccount':
    'Det er en annen Google-konto enn den du holdt på å koble til på nytt. Ingenting ble endret.',
  'connect.outcome.noRefreshToken':
    'Google ga ikke Autho varig tilgang, så Autho ville sluttet å lese innen en time. Ingenting ble koblet til. Fjern Autho under tredjepartstilgang på Google-kontoen din og koble til én gang til.',
  'connect.failed': 'Autho fikk ikke fullført dette: {detail}',
  'connect.tryAgain': 'Start på nytt',

  'nav.counterparties': 'Kunder og leverandører',
  'counterparties.title': 'Kunder og leverandører',
  'counterparties.needsOneCompany':
    'Velg ett selskap. To regnskap kan føres i hver sin valuta, og én liste ville lagt dem sammen.',
  'counterparties.noLedger':
    'Ingen regnskapsløsning er koblet til dette selskapet, så Autho vet ikke hvem det handler med.',
  'counterparties.noSubledger':
    'Dette regnskapet merker ingen konto som kunde- eller leverandørreskontro, så Autho kan ikke si hva som skyldes. Tallene under er null fordi ingenting har sagt hvilke kontoer som er fordringer — ikke fordi ingen skylder noe.',
  'counterparties.empty': 'Ingen kunder eller leverandører i dette regnskapet ennå.',
  'counterparties.filter': 'Vis',
  'counterparties.filter.all': 'Alle',
  'counterparties.filter.customer': 'Kunder',
  'counterparties.filter.supplier': 'Leverandører',
  'counterparties.role.customer': 'Kunde',
  'counterparties.role.supplier': 'Leverandør',
  'counterparties.role.other': 'Annet',
  'counterparties.receivable': 'De skylder oss',
  'counterparties.payable': 'Vi skylder dem',
  'counterparties.behind':
    '{lines, plural, one {# linje} other {# linjer}} fordelt på {vouchers, plural, one {# bilag} other {# bilag}}',
  'counterparties.ageing.title': 'Åpne poster etter alder, {date}',
  'counterparties.ageing.receivables': 'Kundefordringer',
  'counterparties.ageing.payables': 'Leverandørgjeld',
  'counterparties.ageing.carriedIn': 'Inngående',
  'counterparties.ageing.notDue': 'Ikke forfalt',
  'counterparties.ageing.days0to30': '0–30 dager',
  'counterparties.ageing.days31to60': '31–60 dager',
  'counterparties.ageing.days61to90': '61–90 dager',
  'counterparties.ageing.over90': 'Over 90 dager',
  'counterparties.ageing.inCredit': 'Til gode',
  'counterparties.ageing.net': 'Sum',
  'counterparties.ageing.oldest': 'eldste åpne {date}',
  'counterparties.ageing.notNamed':
    'Inkluderer {parties, plural, one {# part} other {# parter}} uten organisasjonsnummer. De kan være personer, så de er tatt med her og navngitt ingen steder.',
  'counterparties.ageing.unattributed':
    'Ført på kunde- og leverandørkontoene uten motpart, og ikke aldersfordelt: {receivable} fordringer, {payable} gjeld.',
  'forecast.title': 'Kontanter, de neste 13 ukene',
  'forecast.needsOneCompany': 'Velg ett selskap for å se hvor kontantene går.',
  'forecast.from.books': 'Fra {cash} i regnskapet {date}.',
  'forecast.from.bank': 'Fra {cash} i banken {date}.',
  'forecast.from.statement': 'Fra {cash} på kontoutskriften {date}.',
  'forecast.week': 'Uke',
  'forecast.in': 'Inn fra kunder',
  'forecast.out': 'Ut til leverandører',
  'forecast.other': 'Alt annet',
  'forecast.closing': 'Kontanter ved ukeslutt',
  'forecast.range': 'Spenn',
  'forecast.timingUnknown':
    'Ikke plassert i noen uke, fordi ingenting i regnskapet sier når de betaler: {receivable} til gode, {payable} skyldig.',
  'forecast.beyond': 'Ventet etter siste uke: {receivable} inn, {payable} ut.',
  'forecast.basis':
    'En prognose, ikke en registrering. Åpne fakturaer plasseres etter når hver kunde pleier å betale, og regninger etter når hver leverandør pleier å få betalt. Alt annet – lønn, husleie, skatter – er snittet for de siste ukene, så skatt står ikke på sin dato. Spennet er de trege og de raske tilfellene, lagt sammen uke for uke.',
  'forecast.withheld.no_books': 'Det er ingen posteringer i regnskapet å lage en prognose fra.',
  'forecast.withheld.books_stale':
    'Regnskapet går til {date}. En prognose fra det ville startet i fortiden, så ingen vises før det er oppdatert.',
  'forecast.withheld.cash_unknown':
    'Kontantbeholdningen i regnskapet er ikke kjent – en inngående saldo ingen har lest, eller ingen bankkonto – så det er ingenting å starte fra.',
  'forecast.withheld.cash_other_currency':
    'Kontantene selskapet har, er i en annen valuta enn regnskapet, så en prognose ville lagt den ene til den andre. Ingen prognose er gitt.',
  'forecast.withheld.history_short':
    'Bare {weeks, plural, one {# uke} other {# uker}} med regnskap så langt. Færre enn fire er ikke et snitt, så ingen prognose vises ennå.',
  'counterparties.ageing.basis':
    'Alder regnes fra bokføringsdato: ingen linje i dette regnskapet har forfallsdato, så dette sier ikke hva som er forfalt. En innbetaling dekker først fakturaen med samme KID eller referanse, ellers eldste faktura. Det som ble tatt med inn i året, har ingen egen dato.',
  'counterparties.ageing.basisDue':
    'Forfalt regnes fra hver fakturas forfallsdato slik regnskapet oppgir den, og ikke forfalt før dagen etter. En innbetaling dekker først fakturaen med samme KID eller referanse, ellers eldste faktura. Det som ble tatt med inn i året, har ingen egen dato.',
  'counterparties.ageing.basisMixed':
    'Forfalt regnes fra forfallsdato der regnskapet oppgir en ({due, plural, one {# åpen faktura} other {# åpne fakturaer}}), og alder fra bokføringsdato der det ikke gjør det ({posting, plural, one {# faktura} other {# fakturaer}}). En innbetaling dekker først fakturaen med samme KID eller referanse, ellers eldste faktura. Det som ble tatt med inn i året, har ingen egen dato.',
  'counterparties.ageing.atBooksEnd':
    'Alder per {date}, siste dag dette regnskapet dekker. Det slutter i et tidligere år, og alder regnet per i dag ville gjort alle åpne fakturaer gamle.',

  'nav.documents': 'Dokumenter',
  'documents.title': 'Dokumenter',
  'documents.empty':
    'Ingen dokumenter ennå. Slipp en fil her, eller velg en, så leser Autho det den kan.',
  'documents.drop': 'Slipp en fil her',
  'documents.or': 'eller',
  'documents.choose': 'Velg en fil',
  'documents.company': 'Selskap',
  'documents.accepted':
    'Dette kan Autho lese: PDF-er med markerbar tekst, ren tekst, og EHF- eller PEPPOL-fakturaer. Inntil {mb} MB.',
  'documents.uploading': 'Leser {filename}…',
  'documents.added': '{filename} er lagt til',
  'documents.alreadyHeld': '{filename} fantes allerede, så ingenting ble endret',
  'documents.refused': '{filename} ble ikke lagt til: {because}',
  'documents.needsOneCompany':
    'Velg ett selskap for å legge til et dokument. Et dokument tilhører ett selskap.',
  'documents.open': 'Åpne',
  'documents.erase': 'Slett',
  'documents.eraseTitle': 'Slette dette dokumentet?',
  'documents.eraseExplain':
    'Filen, teksten som er lest fra den og alt som er utledet av den fjernes. Dette kan ikke angres.',
  'documents.basis': 'På hvilket grunnlag',
  'documents.basisHint':
    'For eksempel: en sletteforespørsel fra personen som er nevnt i dokumentet.',
  'documents.eraseConfirm': 'Slett det',
  'documents.cancel': 'Avbryt',
  'documents.erased': 'Slettet',
  'documents.status.pending': 'Venter på å bli lest',
  'documents.status.extracted': 'Lest',
  'documents.status.failed': 'Kunne ikke leses',
  'documents.status.deferred': 'Venter på kapasitet',
  'documents.ownerOnly': 'Bare eieren kan slette et dokument.',
  'clarify.title': 'Avklar',
  'clarify.empty':
    'Ingenting å avklare. Konflikter, mangler og foreldede opplysninger vises her, de viktigste først.',
  'clarify.kind.merge': 'Mulig duplikat',
  'clarify.kind.conflict': 'Kildene er uenige',
  'clarify.kind.gap': 'Mangler opplysninger',
  'clarify.kind.classification': 'Trenger klassifisering',
  'clarify.kind.staleness': 'Kan være foreldet',
  'clarify.kind.enrichment': 'Berikelse tilgjengelig',
  'clarify.kind.unreadable': 'Kunne ikke lese dokumentet',
  'clarify.financialYear.question':
    'Når starter regnskapsåret for {orgnr}? {file} sier ikke hvilken regnskapsperiode bilagene hører til, så regnskapet leses som kalenderår til det kommer en fil som sier det. Eksporter den på nytt med regnskapsperioder.',
  'clarify.financialYear.aFile': 'Den opplastede filen',
  'clarify.payoff': 'Avklaring kobler {count, plural, one {# post} other {# poster}}',
  'clarify.keepCurrent': 'Behold nåværende verdi',
  'clarify.useIncoming': 'Bruk verdien fra {source}',
  'clarify.skip': 'Hopp over',
  'clarify.resolved': 'Avklart',

  'audit.title': 'Revisjonslogg',
  'audit.description': 'Loggen kan bare utvides — hendelser kan aldri endres eller slettes.',
  'audit.empty': 'Ingen hendelser passer filtrene.',
  'audit.column.time': 'Tid',
  'audit.column.kind': 'Hendelse',
  'audit.column.consumer': 'Utført av',
  'audit.column.entities': 'Enheter',
  'audit.column.outcome': 'Utfall',
  'audit.column.detail': 'Detaljer',
  'audit.filter.kind': 'Hendelsestype',
  'audit.filter.outcome': 'Utfall',
  'audit.filter.company': 'Selskap',
  'audit.filter.wholeProfile': 'Hele profilen',
  'audit.filter.entity': 'Enhet',
  'audit.filter.from': 'Fra',
  'audit.filter.to': 'Til',
  'audit.chain.ok':
    'Integritetskontrollen er godkjent for {count, plural, one {# hendelse} other {# hendelser}}.',
  'audit.chain.broken': 'Integritetskontrollen feilet ved hendelse {seq}. Kontakt kundestøtte.',
  'audit.withheld':
    '{count, plural, one {# tidligere hendelse kan bare ses av personen den gjelder.} other {# tidligere hendelser kan bare ses av personen de gjelder.}}',
  'audit.kind.read': 'Lesing',
  'audit.kind.policy_decision': 'Policybeslutning',
  'audit.kind.action': 'Handling',
  'audit.kind.approval': 'Godkjenning',
  'audit.kind.grant_change': 'Endring i fullmakt',
  'audit.kind.policy_change': 'Endring i policy',
  'audit.kind.connection_change': 'Endring i tilkobling',
  'audit.kind.federated_read': 'Føderert lesing',
  'audit.kind.record_change': 'Endring i post',
  'audit.kind.membership_change': 'Endring i medlemskap',
  'audit.kind.sync': 'Synkronisering',
  'audit.kind.clarify_resolution': 'Avklaring',
  'audit.outcome.success': 'Vellykket',
  'audit.outcome.failure': 'Feilet',
  'audit.outcome.allow': 'Tillatt',
  'audit.outcome.allow_with_approval': 'Krever godkjenning',
  'audit.outcome.deny': 'Avvist',
  'audit.consumer.user': 'Person',
  'audit.consumer.agent': 'Agent',
  'audit.consumer.system': 'System',
  'audit.singleControl': 'Enkeltkontroll',
  'audit.consumer.you': 'Deg',
  'audit.export.csv': 'Eksporter CSV',
  'audit.export.json': 'Eksporter JSON',

  'configure.title': 'Motor',
  'configure.description':
    'Hva Autho kjører på, og hvordan det går. Det den leser fra, står under Kilder.',
  'configure.connections.description': 'Bare leverandører Autho faktisk kan koble til, er oppført.',
  'configure.status.pending': 'Ikke bekreftet',
  'configure.status.live': 'Aktiv',
  'configure.status.error': 'Feil',
  'configure.status.revoked': 'Tilbakekalt',
  'configure.lastSuccess': 'Sist vellykket {ago}',
  'configure.lastAttempt': 'Sist forsøkt {ago}',
  'configure.never': 'Aldri',
  'configure.entities': '{count, plural, =0 {Ingen enheter} one {# enhet} other {# enheter}}',
  'configure.jurisdiction': 'Jurisdiksjon: {code}',
  'configure.mechanism.open': 'Åpent offentlig API, ingen innloggingsdata',
  'configure.verify': 'Bekreft nå',
  'configure.provider.brreg.name': 'Brønnøysundregistrene',
  'configure.provider.brreg.description':
    'Enhetsregisteret, roller, underenheter og innsendte regnskap. Gratis og åpent (NLOD).',

  // Se kommentaren i `en.ts`.
  'settings.providerApps': 'Leverandør-apper',
  'settings.providerApps.explain':
    'Engangsregistreringer andre leverandører gir når Autho registreres som app. Lim dem inn her; hemmeligheter forsegles med leietakerens nøkkel i det de lander, og vises aldri igjen.',
  'settings.providerApps.todoist.where':
    'Fra Todoist: Settings → Integrations → Developer → App Management Console → appen din. Redirect-URL: https://autho.no/connect/todoist/callback',
  'settings.providerApps.todoist.configured': 'Registrert som {clientId}.',
  'settings.providerApps.todoist.connected': 'tilkoblet',
  'settings.providerApps.todoist': 'Todoist',
  'settings.providerApps.clientId': 'Klient-ID',
  'settings.providerApps.clientSecret':
    'Klienthemmelighet (forsegles ved lagring, vises aldri igjen)',
  'settings.providerApps.save': 'Lagre',
  'settings.providerApps.sealed': 'Forseglet og lagret. Hemmeligheten vises ikke igjen.',
  'settings.title': 'Innstillinger',
  'settings.language': 'Språk',
  'settings.language.saving': 'Lagrer…',
  'settings.language.notSaved':
    'Språket du valgte, kunne ikke lagres, så skjermen beholder språket den hadde.',
  'settings.theme': 'Tema',
  'settings.theme.system': 'System',
  'settings.theme.light': 'Lyst',
  'settings.theme.dark': 'Mørkt',

  'palette.placeholder': 'Gå til enhet eller side…',
  'palette.empty': 'Ingen treff',
  'palette.group.screens': 'Sider',
  'palette.group.entities': 'Enheter',
  'palette.shortcut': '⌘K',

  'time.justNow': 'nettopp',

  // ── Hovedbok-synkroniseringer (M1): der en person leser tallene loggen med vilje utelater.
  'entity.ledger.open': 'Synkroniseringer av hovedbok',
  'ledger.title': 'Hovedbok',
  'ledger.description':
    'Synkroniseringer mot regnskapssystemet, og avstemmingen hver av dem gjorde.',
  'ledger.runs.empty': 'Ingen synkroniseringer ennå.',
  'ledger.needsYou.title': 'Trenger deg: bøkene er uenige med regnskapssystemet',
  'ledger.needsYou.body':
    'Siste synkronisering skrev hovedboken, og i perioden ({from} til {to}) beveget {count} konto(er) seg annerledes her enn regnskapssystemet sier. Ingenting er endret for å få dem til å stemme.',
  'ledger.boundary.title': 'Trenger deg: det opplastede regnskapet møter ikke regnskapssystemet',
  'ledger.boundary.body':
    'De opplastede filene avslutter {lastFileYear}, og det tilkoblede regnskapssystemet åpner {boundaryYear}. {count} balansekonto(er) har en annen utgående saldo i filene enn inngående saldo i systemet. Ingenting er endret for å få dem til å møtes.',
  'ledger.boundary.file': 'Filer, utgående',
  'ledger.boundary.connected': 'System, inngående',
  'ledger.boundary.unknown': 'Ukjent',
  'ledger.column.started': 'Startet',
  'ledger.column.mode': 'Modus',
  'ledger.column.status': 'Status',
  'ledger.column.window': 'Periode',
  'ledger.column.read': 'Lest',
  'ledger.column.written': 'Skrevet',
  'ledger.column.crossing': 'Avstemming',
  'ledger.column.account': 'Konto',
  'ledger.column.measure': 'Mål',
  'ledger.column.ours': 'Autho',
  'ledger.column.theirs': 'Kilde',
  'ledger.column.filed': 'Levert',
  'ledger.column.difference': 'Avvik',
  'ledger.mode.dry': 'Prøvekjøring',
  'ledger.mode.probe': 'Sondering',
  'ledger.mode.write': 'Skriving',
  'ledger.mode.unknown': '–',
  'ledger.status.running': 'Pågår',
  'ledger.status.succeeded': 'Fullført',
  'ledger.status.failed': 'Feilet',
  'ledger.status.abandoned': 'Beholdt ingenting (sondering)',
  'ledger.crossing.source': 'Mot kilden',
  'ledger.crossing.filing': 'Mot regnskapet levert til Regnskapsregisteret',
  'ledger.crossing.matches': 'Stemmer på tvers av {accounts} kontoer',
  'ledger.crossing.differs': '{count} av {accounts} kontoer avviker',
  'ledger.crossing.filingMatches': 'Alle {measures} mål stemmer',
  'ledger.crossing.filingDiffers': '{count} av {measures} mål avviker',
  'ledger.crossing.none': 'Ingen avstemming på denne kjøringen.',
  'ledger.crossing.postings':
    'Posteringer etter id: {reported} rapportert, {placed} plassert{neverRead, plural, =0 {} one {, # rapportert men aldri lest} other {, # rapportert men aldri lest}}{notReported, plural, =0 {} one {, # plassert men ikke rapportert} other {, # plassert men ikke rapportert}}',
  'ledger.crossing.explain':
    'Autho beregner saldobalansen fra egne rader; kilden rapporterer sine utgående saldoer; registeret har det som ble levert. Et avvik vises til øret.',
  'ledger.error': 'Feil',
  'ledger.measure.totalLiabilities': 'Sum gjeld',
  'ledger.crossing.atPrecision':
    'Sammenlignet med presisjonen regnskapet oppgir: enheter på {unit}.',
  'ledger.crossing.filingFromYearEnd':
    'Ingen posteringer i Autho for året: sammenlignet med saldoene ved årsslutt oppgitt {date}, uten posteringer.',
  'ledger.crossing.filingNothing':
    'Ingen posteringer i Autho for året og ingen saldoer oppgitt ved årsslutt: ikke sammenlignet, og ingenting avviker.',
  'ledger.crossing.filingMissing': 'Ikke sammenlignet, fordi tallene mangler: {measures}.',
  'ledger.wouldHaveWritten': '{count} (ville ha)',
  'ledger.reconciliation.title': 'Avstemt: alt som ble lest er plassert eller navngitt',
  'ledger.reconciliation.vouchers':
    '{read} bilag lest = {placed} plassert{opening, select, true { + åpningsbilaget} other {}}',
  'ledger.reconciliation.postings':
    '{read} posteringer lest = {lines} linjer + {opening} åpningsposteringer + {orphans} uten bilag + {unknown} med ukjent bilag',
  'ledger.reconciliation.opening':
    '{postings} åpningsposteringer → {balances} saldoer{summed, plural, =0 {} one { (# summert inn i en konto som alt var åpnet)} other { (# summert inn i kontoer som alt var åpnet)}}',
  'ledger.reconciliation.openingLines':
    'Åpningsbalanse: {postings, plural, one {# postering} other {# posteringer}}, plassert som {lines, plural, one {# linje} other {# linjer}} i saldoene ved årsslutt',
  // Configure → Agenter (M1.5): tre livsløp holdt fra hverandre, og en hemmelighet som vises én gang.
  'beliefs.title': 'Oppfatninger',
  'beliefs.description':
    'Det selskapet selv har fortalt Autho, holdt atskilt fra det kildene sier.',
  'beliefs.description.own':
    'Det du har fortalt Autho om deg selv og hvordan du vil ha ting gjort, holdt adskilt fra det kontoene dine sier.',
  'beliefs.write.title': 'Skriv en oppfatning',
  'beliefs.write.needsOneEntity':
    'Velg én enhet for å skrive en oppfatning. En oppfatning hører til ett selskap.',
  'beliefs.write.statement': 'Hva som gjelder her',
  'beliefs.write.type': 'Type',
  'beliefs.write.save': 'Lagre',
  'beliefs.write.saveCorrection': 'Lagre korreksjonen',
  'beliefs.write.correcting': 'Korrigerer: «{statement}»',
  'beliefs.write.cancelCorrection': 'Skriv en ny i stedet',
  'beliefs.write.attribution':
    'Lagres som uttalt av deg, på den høyeste tilliten Autho fører: et menneske har sagt det.',
  'beliefs.list.title': 'Det Autho legger til grunn',
  'beliefs.list.needsOneEntity': 'Velg én enhet for å lese oppfatningene dens.',
  'beliefs.list.empty': 'Ingenting er lagret ennå.',
  'beliefs.list.showForgotten': 'Vis glemte',
  'beliefs.list.version': 'versjon {version}',
  'beliefs.list.forgotten': 'Glemt',
  'beliefs.list.erased': 'Innholdet i denne oppfatningen er slettet. Sporet står igjen.',
  'beliefs.list.correct': 'Korriger',
  'beliefs.list.forget': 'Glem',
  'beliefs.list.forgetIsNotErase':
    'Å glemme stopper bruken av en oppfatning, på alle tidspunkter. Det skriver ikke om historien: raden blir stående, og det gjør sporet også.',
  'approvals.title': 'Godkjenninger',
  'approvals.description':
    'Hva agenter ber om å gjøre her, hva som venter på et menneske, og bryteren som stopper dem.',
  'approvals.onlyAdmins':
    'Bare en eier eller administrator av denne profilen kan stoppe agenter, godkjenne eller endre en regel.',
  'approvals.halt.title': 'Nødstopp',
  'approvals.halt.all':
    'Autho har stoppet alle agenthandlinger fra sin side. Ingenting her kan oppheve det.',
  'approvals.halt.reason': 'Hvorfor (lagres sammen med klikket)',
  'approvals.halt.everything': 'Alle selskaper i denne profilen',
  'approvals.halt.stopped': 'Stoppet',
  'approvals.halt.running': 'Agenter kan handle',
  'approvals.halt.lifts': '{done} av {needed} opphevelser',
  'approvals.halt.stop': 'Stopp agenter',
  'approvals.halt.whyFirst': 'Skriv hvorfor først: Stopp agenter og Opphev venter på det.',
  'approvals.halt.lift': 'Opphev',
  'approvals.halt.counting':
    'Ett klikk stopper agentene med en gang. Å oppheve krever én administrator der profilen har én, og to forskjellige administratorer der den har flere.',
  'approvals.waiting.title': 'Venter på et menneske',
  'approvals.waiting.empty': 'Ingenting venter.',
  'approvals.signInAgain':
    'Å godkjenne krever en innlogging fra de siste fem minuttene, så en åpen økt alene kan ikke si ja. Logg inn på nytt, og godkjenn deretter.',
  'approvals.signInAgain.button': 'Logg inn på nytt',
  'approvals.waiting.recheck':
    'En godkjent handling sjekkes på nytt før den utføres: har nødstoppen, regelen eller tilgangen endret seg siden, blir den annullert og ingenting skrives.',
  'approvals.item.asks': '{agent} ber om å {action} om {entity}',
  'approvals.item.grant': 'under tilgangen «{purpose}»',
  'approvals.item.expires': 'utløper {when}',
  'approvals.item.approve': 'Godkjenn',
  'approvals.item.reject': 'Avvis',
  'approvals.action.remember': 'legge igjen et notat',
  'approvals.reason.over_approval_threshold': 'over godkjenningsgrensen',
  'approvals.reason.over_dual_control_threshold': 'over grensen for to personer',
  'approvals.reason.no_exchange_rate': 'ingen valutakurs for dagen',
  'approvals.reason.total_unknown': 'løpende sum kunne ikke leses',
  'approvals.reason.new_counterparty': 'en ny motpart',
  'approvals.reason.no_contract_or_po': 'ingen kontrakt eller innkjøpsordre',
  'approvals.reason.low_confidence': 'agenten er ikke sikker nok',
  'approvals.status.waiting': 'Venter',
  'approvals.status.approved': 'Godkjent',
  'approvals.status.rejected': 'Avvist',
  'approvals.status.expired': 'Utløpt',
  'approvals.status.void': 'Annullert',
  'approvals.status.executed': 'Utført',
  'approvals.rules.title': 'Regler',
  'approvals.rules.remember':
    'Legge igjen et notat: en agent med tilgang til det kan skrive et notat om et selskap. Notater vises alltid som en agents notat, aldri som noe selskapet har sagt. Under terskelen må et menneske godkjenne notatet først.',
  'approvals.rules.none': 'Ingen regel er slått på, så agenter kan bare lese.',
  'approvals.rules.on': 'På',
  'approvals.rules.waiting': 'Venter på en administrator til ({done} av 2)',
  'approvals.rules.floor': 'terskel {floor}',
  'approvals.rules.singleControl': 'besluttet av én person',
  'approvals.rules.approve': 'Godkjenn',
  'approvals.rules.off': 'Slå av',
  'approvals.rules.floorInput': 'Terskel (0 til 1)',
  'approvals.rules.switchOn': 'Slå på',
  'approvals.rules.oneAdmin':
    'Denne profilen har én administrator: en regel som slås på her, gjelder med en gang og merkes som besluttet av én person.',
  'approvals.rules.twoAdmins':
    'Å slå på eller endre en regel venter på en administrator til. Å slå den av skjer med en gang.',
  'beliefs.list.agentsNote': 'En agents notat',
  'beliefs.list.eraseNote': 'Visk ut notatet',
  'beliefs.type.fact': 'Faktum',
  'beliefs.type.preference': 'Preferanse',
  'beliefs.type.pattern': 'Mønster',
  'beliefs.type.instruction': 'Instruks',
  'beliefs.type.decision': 'Beslutning',
  'beliefs.type.convention': 'Konvensjon',
  'beliefs.type.constraint': 'Begrensning',
  'beliefs.type.correction': 'Korreksjon',
  'beliefs.confidence.stated': 'Uttalt',
  'beliefs.confidence.confirmed': 'Bekreftet',
  'beliefs.confidence.extracted': 'Utlest',
  'beliefs.confidence.inferred': 'Utledet',
  'agents.title': 'Agenter',
  'agents.description': 'Hva som får lese dette konsernet, under hvilken fullmakt, og hvor lenge.',
  'agents.none': 'Ingen agent er opprettet ennå.',
  'agents.never': 'aldri',
  'agents.expires': 'utløper',
  'agents.revoked': 'trukket tilbake',
  'agents.enable': 'Slå på',
  'agents.disable': 'Slå av',
  'agents.revoke': 'Trekk tilbake',
  'agents.status.enabled': 'På',
  'agents.status.disabled': 'Av — alle oppslag avvises',
  'agents.status.revoked': 'Trukket tilbake',
  'agents.create.title': 'Ny agent',
  'agents.create.submit': 'Opprett',
  'agents.create.starts_disabled':
    'En agent opprettes avslått og leser ingenting før du slår den på og gir den en fullmakt.',
  'agents.field.name': 'Navn',
  'agents.field.version': 'Versjon',
  'agents.secret.title': 'Nøkkelen, vist én gang',
  'agents.secret.once':
    'Kopier den inn i agenten nå. Autho lagrer bare et hashet avtrykk og kan aldri vise den igjen.',
  'agents.secret.dismiss': 'Jeg har kopiert den',
  'agents.credentials.title': 'Nøkler',
  'agents.credentials.issue': 'Utsted nøkkel',
  'agents.credentials.none': 'Ingen nøkkel er utstedt.',
  'agents.credentials.folded':
    '{count} utløpt(e) eller tilbakekalt(e) nøkkel(er), tatt vare på for ettertiden',
  'agents.credentials.revokedOn': 'tilbakekalt {date}',
  'agents.credentials.expiredOn': 'utløpt {date}',
  'agents.credentials.prefix': 'Prefiks',
  'agents.credentials.last_used': 'Sist brukt til oppslag',
  'agents.credentials.actions': 'Handlinger',
  'agents.grants.title': 'Fullmakter',
  'agents.grants.none': 'Ingen fullmakt. Agenten autentiseres og avvises på alt.',
  'agents.grants.new': 'Ny fullmakt',
  'agents.grants.entities': 'Enheter',
  'agents.grants.accounts': 'Tilkoblede kontoer',
  'agents.grants.profile': 'Denne profilen',
  'agents.grants.this_profile': 'Din egen profil',
  'agents.grants.readsBeliefs':
    'me.beliefs lar denne agenten lese det du har fortalt Autho om ditt eget liv — vanene, preferansene, beslutningene og instruksene dine, hver med hvem som sa det og når. Den leser dem og ingenting annet: den kan ikke registrere, rette eller glemme én. Ingen annen ressurs her omfatter den.',
  'agents.grants.readsContents':
    'me.mail.read lar denne agenten lese hva en melding sier — teksten i den — og ikke bare at den kom. Alle de andre ressursene her gir den pekere: et emne, hvem som var med, et tall. Ingenting lagres når den leser én; meldingen hentes fra leverandøren i det øyeblikket, og revisjonsloggen skriver hvilken melding, under hvilken tilgang.',
  'agents.grants.scope_hint':
    'Huk av hva den får lese først: det avgjør om denne tilgangen navngir selskaper eller kontoer.',
  'agents.grants.scope_hint_me':
    'Huk av hva den får lese først: det avgjør om denne tilgangen navngir tilkoblede kontoer eller denne profilen.',
  'agents.grants.scope_mixed':
    'En tilgang navngir én type ting. Selskapsressurser gis per selskap, e-post, kalender og filer per tilkoblet konto, og me.beliefs for hele denne profilen — lag to tilganger.',
  'agents.grants.unreached':
    'Denne tilgangen navngir {count, plural, one {\u00e9n ting} other {# ting}} den ikke kan lese: {what}. Den svarer ingenting for de.',
  'agents.grants.unreached_entity': 'et selskap, mens denne tilgangen leser kontoer',
  'agents.grants.unreached_account': 'en konto, mens denne tilgangen leser selskaper',
  'agents.grants.unreached_gone': 'en konto som ikke er tilkoblet lenger',
  'agents.grants.kind_org': 'Per selskap',
  'agents.grants.kind_me': 'Per tilkoblet konto',
  'agents.grants.kind_profile': 'For denne profilen',
  'agents.grants.resources': 'Ressurser',
  'agents.grants.purpose': 'Formål: {purpose} — registrert, ikke håndhevet',
  'agents.grants.purpose_label': 'Formål, i ord (minst 8 tegn)',
  'agents.grants.scope': '{count, plural, one {# enhet} other {# enheter}}',
  'agents.grants.days': 'Dager',
  'agents.grants.submit': 'Gi fullmakt',
  'agents.grants.expiry_note':
    'Enhver fullmakt utløper, og varer høyst 90 dager. Fornyelse er en ny fullmakt, aldri en forlengelse.',
  'agents.grant_status.active': 'aktiv',
  'agents.grant_status.expired': 'utløpt',
  'agents.grant_status.revoked': 'trukket tilbake',
  'audit.kind.credential_change': 'Nøkkelendring',
  'audit.kind.agent_change': 'Agentendring',
  'audit.underGrant': 'under fullmakt {id}',
  'nav.profile': 'Profil',
  'nav.finances': 'Økonomi',
  'nav.goals': 'Mål',
  'goals.title': 'Mål',
  'goals.description':
    'Det du arbeider mot, og hva hvert mål venter på. Du skriver inn et mål; Autho lager aldri ett.',
  'goals.empty':
    'Ingen mål ennå. Legg til ett over: en tittel, hvorfor det betyr noe, og dagen du mener det innen.',
  'goals.new': 'Nytt mål',
  'goals.add': 'Legg til mål',
  'goals.suggestOnly': 'Assistenten kan foreslå et mål. Bare du legger det til.',
  'goals.field.title': 'Mål',
  'goals.field.why': 'Hvorfor',
  'goals.field.horizon': 'Innen',
  'goals.field.state': 'Status',
  'goals.state.active': 'Aktivt',
  'goals.state.paused': 'På pause',
  'goals.state.achieved': 'Nådd',
  'goals.state.abandoned': 'Lagt bort',
  'goals.by': 'innen {date}',
  'goals.next': 'Neste: {step}, frist {date}',
  'goals.next.undated': 'Neste: {step}, uten dato',
  'goals.next.none':
    'Ingenting som er koblet er åpent. Koble en forpliktelse eller en oppgave for å gi målet et neste steg.',
  'goals.links': 'Det dette målet venter på',
  'goals.link.task': 'Todoist',
  'goals.link.commitment': 'Fra e-posten din',
  'goals.link.gone': 'ikke lenger på Todoist-listen din',
  'goals.link.closed': 'gjort eller glemt',
  'goals.link.open': 'Åpne',
  'goals.link': 'Koble',
  'goals.unlink': 'Fjern kobling',
  'goals.linkCommitment': 'Koble en forpliktelse',
  'goals.choose': 'Velg…',
  'goals.edit': 'Endre',
  'goals.edit.close': 'Lukk',
  'goals.save': 'Lagre',
  'goals.error.title': 'Gi målet en tittel.',
  'goals.error.tooLong': 'Det er for langt.',
  'goals.error.horizon': 'Det er ikke en dato.',
  'goals.error.alreadyLinked': 'Det er allerede koblet til dette målet.',
  'goals.todoist.title': 'Todoist-listen din',
  'goals.todoist.explain':
    'Lest fra Todoist hver gang denne siden åpnes, og aldri lagret. Autho leser oppgavene dine og skriver ingenting til listen. Hvem og hva en oppgave nevner, er et forslag ut fra navnene Autho allerede har.',
  'goals.todoist.not_connected': 'Todoist-listen din er ikke koblet til.',
  'goals.todoist.registration':
    'Tilkoblingen trenger Todoist-appregistreringen din, limt inn én gang under',
  'goals.todoist.failed':
    'Todoist-listen din kunne ikke leses akkurat nå, så oppgavene vises ikke. Ingenting er endret.',
  'goals.todoist.paused': 'Todoist-listen din er satt på pause, så oppgavene leses ikke.',
  'goals.todoist.read': 'Lest fra Todoist akkurat nå.',
  'goals.todoist.empty': 'Todoist-listen din har ingen åpne oppgaver.',
  'goals.task.line': 'Oppgave',
  'goals.task.due': 'Frist',
  'goals.task.priority': 'Prioritet',
  'goals.task.names': 'Nevner',
  'goals.task.goal': 'Mål',
  'goals.task.suggested': 'Foreslått ut fra oppgavens tekst; ikke en kobling du har laget',
  'goals.task.kind.person': 'Person',
  'goals.task.kind.organisation': 'Organisasjon',
  'goals.task.kind.asset': 'Eiendel',
  'goals.task.linkTo': 'Koble «{task}» til et mål',
  'inbox.goal': 'Et steg mot: {goal}',
  'inbox.goalTasks.not_connected':
    'Et mål er koblet til en Todoist-oppgave, og Todoist-listen din er ikke koblet til, så oppgavene er ikke på denne listen.',
  'inbox.goalTasks.paused':
    'Todoist-listen din er satt på pause, så en oppgave for et mål som har frist, er ikke på denne listen.',
  'inbox.goalTasks.failed':
    'Todoist-listen din kunne ikke leses akkurat nå, så en oppgave for et mål som har frist, kan mangle på denne listen.',
  'accounts.todoist.goals': 'Todoist-listen din, for Mål',
  'accounts.todoist.goals.explain':
    'Autho leser de åpne oppgavene dine når du åpner Mål eller Innboks, og lagrer dem aldri. Tilgangen lar Autho bare lese oppgavene dine: Autho skriver ingenting til listen, og et token som ikke kan lese, blir avvist og trukket tilbake.',
  'todoist.callback.connected.goals':
    'Koblet til. Autho kan lese Todoist-listen din for Målene dine, og skriver ingenting til den.',
  'todoist.callback.cannotRead':
    'Todoist ga tilbake et token som ikke kan lese listen din, så ingenting ble beholdt og tokenet ble trukket tilbake.',
  'settings.providerApps.explain.me':
    'Dine egne registreringer: Todoists, for å lese listen din inn i Mål, og Enable Bankings applikasjons-ID, for dine egne bankkontoer. Lim dem inn her; en hemmelighet forsegles i det øyeblikket den kommer inn, og vises aldri igjen.',
  'profile.title': 'Profil',
  'profile.description': 'Hvem du er, slik du har skrevet det. Ingenting her er lest fra en konto.',
  'profile.field.fullName': 'Navn',
  'profile.field.birthDate': 'Fødselsdato',
  'profile.field.address': 'Adresse',
  'profile.field.household': 'Husstand',
  'profile.updated': 'Sist endret {when}',
  'profile.empty': 'Ingenting skrevet inn ennå.',
  'profile.save': 'Lagre',
  'profile.saved': 'Lagret.',
  'profile.error.birthDate': 'Den fødselsdatoen er ikke en dato mellom 1900 og i dag.',
  'profile.error.tooLong': 'Ett av feltene er for langt.',
  'finances.title': 'Økonomi',
  'finances.description':
    'Det du eier og det du skylder, slik du har skrevet det. En ny verdi beholder den gamle som historikk; en verdi i en annen valuta forblir i den valutaen.',
  'finances.provenance': 'Alt på denne siden er oppgitt av deg.',
  'finances.totals': 'Summer',
  'finances.totals.none': 'Ingenting har en verdi ennå, så det er ingenting å summere.',
  'finances.totals.assets': 'Eiendeler',
  'finances.totals.liabilities': 'Gjeld',
  'finances.totals.bank': 'I banken',
  'finances.bank': 'Bankkontoer',
  'finances.bank.explain':
    'Dine egne kontoer, koblet til med ditt eget samtykke i banken din og lest når denne siden åpnes. Saldoer og transaksjoner leses fra banken og lagres aldri. Autho leser og betaler, flytter eller setter aldri i gang noe.',
  'finances.bank.none': 'Ingen bank er koblet til.',
  'finances.bank.connect': 'Koble til en bank',
  'finances.bank.pick': 'Banken din',
  'finances.bank.connect.go': 'Gå videre til banken',
  'finances.bank.connect.explain':
    'Du gir samtykket med BankID på bankens egne sider. Det lar Autho lese saldoer og transaksjoner til det utløper, og ingenting annet.',
  'finances.bank.registration':
    'Tilkoblingen trenger Enable Banking-applikasjons-ID-en, limt inn én gang under',
  'finances.bank.account': 'Konto',
  'finances.bank.balance': 'Saldo',
  'finances.bank.consent': 'Samtykke',
  'finances.bank.asOf': 'per {date}',
  'finances.bank.until': 'til {date}',
  'finances.bank.lines': 'Inntekter og betalinger som gjentar seg',
  'finances.bank.lines.explain':
    'Lest ut av transaksjonene dine: samme motpart minst tre ganger i en jevn rytme. Bare et sammendrag av hver linje beholdes – motparten, rytmen, det vanlige beløpet og hvilke transaksjoner den er lest ut av – aldri selve transaksjonene. Hver er et forslag til du bekrefter den eller glemmer den.',
  'finances.bank.lines.none': 'Ingenting gjentar seg ennå i det banken har gitt.',
  'finances.bank.direction': 'Retning',
  'finances.bank.counterpart': 'Motpart',
  'finances.bank.cadence': 'Rytme',
  'finances.bank.usual': 'Vanlig beløp',
  'finances.bank.next': 'Neste ventet',
  'finances.bank.verdict': 'Ditt svar',
  'finances.bank.in': 'Inntekt',
  'finances.bank.out': 'Betaling',
  'finances.bank.basis': 'Transaksjonene den ble lest ut av',
  'finances.bank.basis.unread': 'ikke lest akkurat nå',
  'finances.bank.cadence.weekly': 'Ukentlig',
  'finances.bank.cadence.monthly': 'Månedlig',
  'finances.bank.cadence.quarterly': 'Kvartalsvis',
  'finances.bank.cadence.yearly': 'Årlig',
  'finances.bank.state.proposed': 'Foreslått',
  'finances.bank.state.confirmed': 'Bekreftet',
  'finances.bank.state.forgotten': 'Glemt',
  'finances.bank.kind': 'Hva «{line}» er',
  'finances.bank.kind.none': 'Ikke sagt',
  'finances.bank.kind.salary': 'Lønn',
  'finances.bank.kind.rent': 'Husleie',
  'finances.bank.kind.subscription': 'Abonnement',
  'finances.bank.kind.loan': 'Lån',
  'finances.bank.kind.other': 'Annet',
  'finances.bank.confirm': 'Bekreft',
  'finances.bank.forget': 'Glem',
  'finances.totals.net': 'Netto',
  'finances.totals.notConverted':
    'Én linje per valuta: Autho regner ikke om fra én valuta til en annen.',
  'finances.assets': 'Eiendeler',
  'finances.assets.add': 'Legg til en eiendel',
  'finances.assets.addSubmit': 'Legg til eiendel',
  'finances.assets.empty':
    'Ingen eiendeler ennå. Legg til en etter type: hva den er, din andel og hvor involvert du er.',
  'finances.liabilities': 'Gjeld',
  'finances.liabilities.add': 'Legg til gjeld',
  'finances.liabilities.addSubmit': 'Legg til gjeld',
  'finances.liabilities.empty': 'Ingen gjeld ennå.',
  'finances.step.type': 'Type',
  'finances.step.stake': 'Andel',
  'finances.step.value': 'Verdi (valgfritt)',
  'finances.type.class': 'Klasse',
  'finances.type.subclass': 'Underklasse',
  'finances.type.vehicle': 'Form',
  'finances.type.choose': 'Velg…',
  'finances.name': 'Navn',
  'finances.notes': 'Notater',
  'finances.save': 'Lagre',
  'finances.cancel': 'Avbryt',
  'finances.edit': 'Endre',
  'finances.edit.title': 'Endre {name}',
  'finances.stake.shares': 'Aksjer',
  'finances.stake.units': 'Andeler',
  'finances.stake.face': 'Pålydende',
  'finances.stake.quantity': 'Antall',
  'finances.stake.unique': 'Ett eksemplar',
  'finances.stake.none': 'Ingenting å oppgi her: verdien er beholdningen.',
  'finances.stake.field.shareClass': 'Aksjeklasse',
  'finances.stake.field.outstanding': 'Utstedte aksjer',
  'finances.stake.field.percent': 'Andel, i prosent',
  'finances.stake.field.rate': 'Rente, % per år',
  'finances.stake.field.maturity': 'Forfaller',
  'finances.stake.shown.shares': '{shares} aksjer',
  'finances.stake.shown.units': '{units} andeler',
  'finances.stake.shown.face': '{face} pålydende',
  'finances.stake.shown.quantity': '{quantity}',
  'finances.band.financial': 'Finansiell interesse',
  'finances.band.significant': 'Betydelig innflytelse',
  'finances.band.joint': 'Felles kontroll',
  'finances.band.majority': 'Flertall',
  'finances.band.wholly': 'Heleid',
  'finances.involvement': 'Involvering',
  'finances.involvement.passive': 'Passiv',
  'finances.involvement.active': 'Aktiv',
  'finances.involvement.operating': 'Driver selv',
  'finances.value.amount': 'Beløp',
  'finances.value.currency': 'Valuta',
  'finances.value.asOf': 'Per dato',
  'finances.value.new': 'Ny verdi',
  'finances.value.newBalance': 'Ny saldo',
  'finances.value.save': 'Lagre verdi',
  'finances.noValue': 'Ingen verdi ennå',
  'finances.asOf': 'per {day}',
  'finances.history': '{count, plural, one {# tidligere verdi} other {# tidligere verdier}}',
  'finances.column.name': 'Navn',
  'finances.column.type': 'Type',
  'finances.column.stake': 'Andel',
  'finances.column.involvement': 'Involvering',
  'finances.column.value': 'Verdi',
  'finances.column.acts': 'Hva du kan gjøre',
  'finances.ended': 'Avsluttet, beholdt som historikk',
  'finances.endedOn': 'Avsluttet {day}',
  'finances.paidOn': 'Nedbetalt {day}',
  'finances.end.asset': 'Avslutt',
  'finances.end.liability': 'Nedbetalt',
  'finances.end.asset.on': 'Avsluttet den',
  'finances.end.liability.on': 'Nedbetalt den',
  'finances.end.asset.confirm': 'Avslutt den',
  'finances.end.liability.confirm': 'Merk som nedbetalt',
  'finances.end.kept': 'Den blir stående her som historikk og endres ikke lenger.',
  'finances.liability.kind': 'Type',
  'finances.liability.kind.loan': 'Lån',
  'finances.liability.kind.credit_card': 'Kredittkort',
  'finances.liability.kind.other': 'Annet',
  'finances.liability.lender': 'Långiver',
  'finances.liability.balance': 'Saldo',
  'finances.error.stake_required': 'Oppgi andelen denne typen ber om.',
  'finances.error.stake_not_a_number': 'Den andelen er ikke et tall.',
  'finances.error.stake_out_of_range': 'Den andelen er utenfor det den kan være.',
  'finances.error.outstanding_below_shares':
    'Utstedte aksjer kan ikke være færre enn aksjene du eier.',
  'finances.error.involvement_required': 'Oppgi om du er passiv, aktiv eller driver selv.',
  'finances.error.name_required': 'Gi den et navn.',
  'finances.error.text_too_long': 'Den teksten er for lang.',
  'finances.error.invalid_date': 'Det er ikke en dato.',
  'finances.error.date_in_future': 'Den datoen har ikke kommet ennå.',
  'finances.error.currency_unknown': 'Det er ikke en valutakode.',
  'finances.error.value_not_a_number': 'Den verdien er ikke et beløp med høyst to desimaler.',
  'finances.error.holding_ended': 'Den er avsluttet; den beholdes som historikk og endres ikke.',
  'taxonomy.class.public_markets': 'Børsnoterte verdier',
  'taxonomy.class.private_equity': 'Unotert egenkapital',
  'taxonomy.class.private_credit': 'Privat kreditt',
  'taxonomy.class.real_assets': 'Realaktiva',
  'taxonomy.class.commodities': 'Råvarer',
  'taxonomy.class.cash': 'Kontanter og innskudd',
  'taxonomy.class.digital_assets': 'Digitale eiendeler',
  'taxonomy.class.pensions_insurance': 'Pensjon og forsikring',
  'taxonomy.class.collectibles': 'Samleobjekter og alternativer',
  'taxonomy.class.intellectual_property': 'Immaterielle rettigheter',
  'taxonomy.subclass.stock': 'Aksje',
  'taxonomy.subclass.bond': 'Obligasjon',
  'taxonomy.subclass.fund': 'Fond',
  'taxonomy.subclass.etf': 'Børsnotert fond (ETF)',
  'taxonomy.subclass.reit': 'Eiendomsfond (REIT)',
  'taxonomy.subclass.derivatives': 'Derivater og opsjoner',
  'taxonomy.subclass.venture_capital': 'Venturekapital',
  'taxonomy.subclass.growth_equity': 'Vekstkapital',
  'taxonomy.subclass.buyout': 'Oppkjøp',
  'taxonomy.subclass.private_company': 'Unotert selskap',
  'taxonomy.subclass.equity_compensation': 'Aksjebasert godtgjørelse',
  'taxonomy.subclass.direct_loan': 'Direkte lån',
  'taxonomy.subclass.shareholder_loan': 'Aksjonærlån',
  'taxonomy.subclass.convertible_note': 'Konvertibelt lån',
  'taxonomy.subclass.personal_loan': 'Privatlån / gjeldsbrev',
  'taxonomy.subclass.residential': 'Eiendom: bolig',
  'taxonomy.subclass.commercial': 'Eiendom: næring',
  'taxonomy.subclass.land': 'Eiendom: tomt og grunn',
  'taxonomy.subclass.infrastructure': 'Infrastruktur',
  'taxonomy.subclass.natural_resources': 'Naturressurser',
  'taxonomy.subclass.precious_metals': 'Edle metaller',
  'taxonomy.subclass.industrial_metals': 'Industrimetaller',
  'taxonomy.subclass.energy': 'Energi',
  'taxonomy.subclass.agriculture': 'Landbruk',
  'taxonomy.subclass.bank_deposit': 'Bankinnskudd',
  'taxonomy.subclass.physical_cash': 'Kontanter',
  'taxonomy.subclass.receivable': 'Fordring',
  'taxonomy.subclass.cryptocurrency': 'Kryptovaluta',
  'taxonomy.subclass.stablecoins': 'Stablecoins',
  'taxonomy.subclass.tokens': 'Tokens',
  'taxonomy.subclass.nfts': 'NFT-er',
  'taxonomy.subclass.staked_defi': 'Staking / DeFi-posisjoner',
  'taxonomy.subclass.occupational_pension': 'Tjenestepensjon (innskuddspensjon / OTP)',
  'taxonomy.subclass.individual_pension': 'Individuell pensjonssparing (IPS)',
  'taxonomy.subclass.pension_capital_certificate': 'Pensjonskapitalbevis',
  'taxonomy.subclass.paid_up_policy': 'Fripolise',
  'taxonomy.subclass.life_insurance': 'Livsforsikring med gjenkjøpsverdi',
  'taxonomy.subclass.annuity': 'Livrente',
  'taxonomy.subclass.art': 'Kunst',
  'taxonomy.subclass.watches_jewelry': 'Klokker og smykker',
  'taxonomy.subclass.vehicles_boats_aircraft': 'Kjøretøy, båter og fly',
  'taxonomy.subclass.wine_spirits': 'Vin og brennevin',
  'taxonomy.subclass.other': 'Annet',
  'taxonomy.subclass.patents_technology': 'Patenter og teknologi',
  'taxonomy.subclass.copyrights_media': 'Opphavsrett og medier',
  'taxonomy.subclass.trademarks_brands': 'Varemerker',
  'taxonomy.subclass.domain_names': 'Domenenavn',
  'taxonomy.subclass.royalties': 'Royalties',
  'taxonomy.vehicle.direct': 'Direkte',
  'taxonomy.vehicle.secondary': 'Sekundær',
  'taxonomy.vehicle.fund': 'Fond',
  'taxonomy.vehicle.operating_company': 'Driftsselskap',
  'taxonomy.vehicle.holding_company': 'Holdingselskap',
  'taxonomy.vehicle.sole_proprietorship': 'Enkeltpersonforetak (ENK)',
  'taxonomy.vehicle.options': 'Opsjoner',
  'taxonomy.vehicle.warrants': 'Tegningsretter',
  'taxonomy.vehicle.rsus': 'RSU-er',
  'taxonomy.vehicle.phantom_shares': 'Fantomaksjer',
  'taxonomy.vehicle.primary_residence': 'Egen bolig',
  'taxonomy.vehicle.rental_property': 'Utleiebolig',
  'taxonomy.vehicle.holiday_property': 'Fritidsbolig (hytte)',
  'taxonomy.vehicle.coop_share': 'Andel i borettslag',
  'taxonomy.vehicle.office': 'Kontor',
  'taxonomy.vehicle.retail': 'Handel',
  'taxonomy.vehicle.industrial': 'Industri',
  'taxonomy.vehicle.hospitality': 'Hotell og servering',
  'taxonomy.vehicle.development': 'Utvikling',
  'taxonomy.vehicle.agricultural': 'Landbruk',
  'taxonomy.vehicle.forestry': 'Skog',
  'taxonomy.vehicle.undeveloped': 'Ubebygd',
  'taxonomy.vehicle.energy': 'Energi',
  'taxonomy.vehicle.transportation': 'Transport',
  'taxonomy.vehicle.utilities': 'Forsyning',
  'taxonomy.vehicle.direct_ownership': 'Direkte eierskap',
  'taxonomy.vehicle.royalty_rights': 'Royalty / rettigheter',
};
